import React, { useState, useRef, useEffect, useCallback, useContext } from "react";
import { Button, Form, Table, Modal, Alert } from "react-bootstrap";
import { FaEye, FaDownload, FaTrash, FaUpload, FaEdit, FaReceipt } from "react-icons/fa";
import Papa from "papaparse";
import { useNavigate, useLocation } from "react-router-dom";
import { saveAs } from "file-saver";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BASE_URL, updateInvoiceStatusNetworkForApproved } from "../../api/api";
import { IconButton } from "@mui/material";
import pdfimage from "../images/pdf_downlaod.png";
import { AuthContext } from "../../context/AuthContext";
import Swal from "sweetalert2";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { statusColor } from "../../utils/statusColor";

function ApprovalBatchPage() {
  const { user } = useContext(AuthContext);
  const isDisabled = user?.role === "NetworkSubAdmin"
  const navigate = useNavigate();
  const location = useLocation();
  const { batchData, batchNo, invoiceStatus } = location.state || {};
  const fileInputRef = useRef();
  const modalFileInputRef = useRef();
  const [nextAction, setNextAction] = useState(null);
  const [modalActionType, setModalActionType] = useState("");
  const [invoices, setInvoices] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isGSTApplied, setIsGSTApplied] = useState(true);
  const [apiData, setApiData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [fileType, setFileType] = useState("");
  const [showEditModal, setShowEditModal] = useState(false);
  const [editingInvoice, setEditingInvoice] = useState(null);
  const [existingInvoice, setExistingInvoice] = useState({
    url: null,
    fileName: null,
    fileType: null,
  });
  const [invoiceNo, setInvoiceNo] = useState("");
  const [caseCount, setCaseCount] = useState("");
  const [invoiceDate, setInvoiceDate] = useState("");
  const [invoiceAmount, setInvoiceAmount] = useState("");
  const [amountError, setAmountError] = useState("");
  const [caseCountError, setCaseCountError] = useState("");
  const [hoveredRow, setHoveredRow] = useState(null);
  const [openRemarkModal, setOpenRemarkModal] = useState(false);
  const [selectedInvoiceIndex, setSelectedInvoiceIndex] = useState(null);
  const [remarks, setRemarks] = useState("");
  const [remarkFile, setRemarkFile] = useState(null);
  const [fieldErrors, setFieldErrors] = useState({
    invoiceNo: false,
    invoiceDate: false,
    invoiceAmount: false,
    caseCount: false,
    invoiceFile: false,
    remarks: {},
  });
  const [editValues, setEditValues] = useState({
    serviceCharges: "",
    repairCharges: "",
    chargesInclGST: "",
    remarks: "",
    remarkFile: null,
    billingType: "billing",
    fileName: "",
  });
  const [modalClaimData, setModalClaimData] = useState(null);
  const [activePreviewTab, setActivePreviewTab] = useState("challan");
  const [showPreview, setShowPreview] = useState(false);
  const [showRemarkModal, setShowRemarkModal] = useState(false);
  const [batchRemark, setBatchRemark] = useState("");

  const numberToWords = (num) => {
    const a = ['', 'One ', 'Two ', 'Three ', 'Four ', 'Five ', 'Six ', 'Seven ', 'Eight ', 'Nine ', 'Ten ', 'Eleven ', 'Twelve ', 'Thirteen ', 'Fourteen ', 'Fifteen ', 'Sixteen ', 'Seventeen ', 'Eighteen ', 'Nineteen '];
    const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

    if ((num = num.toString()).length > 9) return 'overflow';
    let n = ('000000000' + num).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
    if (!n) return '';
    let str = '';
    str += parseInt(n[1]) !== 0 ? (a[Number(n[1])] || b[n[1][0]] + ' ' + a[n[1][1]]) + 'Crore ' : '';
    str += parseInt(n[2]) !== 0 ? (a[Number(n[2])] || b[n[2][0]] + ' ' + a[n[2][1]]) + 'Lakh ' : '';
    str += parseInt(n[3]) !== 0 ? (a[Number(n[3])] || b[n[3][0]] + ' ' + a[n[3][1]]) + 'Thousand ' : '';
    str += parseInt(n[4]) !== 0 ? (a[Number(n[4])] || b[n[4][0]] + ' ' + a[n[4][1]]) + 'Hundred ' : '';
    str += parseInt(n[5]) !== 0 ? ((str !== '') ? 'and ' : '') + (a[Number(n[5])] || b[n[5][0]] + ' ' + a[n[5][1]]) : '';
    return str.trim() ? str.trim() + ' Rupees Only' : 'Zero Rupees Only';
  };

  const getHsnSac = (materialName) => {
    const name = (materialName || "").toUpperCase();
    if (name.includes("DISPLAY")) return "85177990";
    if (name.includes("FRAME")) return "85177990";
    if (name.includes("BATTERY")) return "39269099";
    if (name.includes("COVER")) return "39269099";
    if (name.includes("STICKER")) return "48239090";
    if (name.includes("SERVICE") || name.includes("LOGISTIC")) return "998716";
    return "85177990"; // default fallback HSN
  };

  const getVendorDetails = (vendorName, state) => {
    const defaults = {
      name: vendorName || "Chitransh Enterprises",
      address: "1685, Shyam Nath Tiwari Ki Gali, Choura Rasta, Jaipur",
      phone: "9460871655",
      gstin: "08AUMPB7316G1ZO",
      state: "08-Rajasthan"
    };

    const nameUpper = (vendorName || "").toUpperCase();
    if (nameUpper.includes("CHITRANSH")) {
      return defaults;
    } else if (nameUpper.includes("NPD")) {
      return {
        name: "NPD Enterprises - Meerut",
        address: "Meerut Road, Near Bypass, Meerut",
        phone: "9837011777",
        gstin: "09AUMPB7316G1ZO",
        state: "09-Uttar Pradesh"
      };
    }

    const stateStr = state || "Rajasthan";
    const stateCode = stateStr.toUpperCase().includes("UTTAR PRADESH") ? "09" : "08";
    return {
      name: vendorName || "Chitransh Enterprises",
      address: stateStr + ", India",
      phone: "9460871655",
      gstin: `${stateCode}AUMPB7316G1ZO`,
      state: `${stateCode}-${stateStr}`
    };
  };

  const getDisplayItems = () => {
    const inputRepair = parseFloat(editValues.repairCharges) || 0;
    const inputService = parseFloat(editValues.serviceCharges) || 0;

    const formattedRepairParts = [];
    if (inputRepair > 0) {
      formattedRepairParts.push({
        name: "Repair Charges",
        hsn: "",
        quantity: 1,
        unit: "Pcs",
        price: inputRepair,
        gstRate: 18,
        gstAmount: isGSTApplied ? inputRepair * 0.18 : 0,
        amount: isGSTApplied ? inputRepair * 1.18 : inputRepair
      });
    }

    const formattedServiceParts = [];
    if (inputService > 0) {
      formattedServiceParts.push({
        name: "Logistic Charges",
        hsn: "",
        quantity: 1,
        unit: "Pcs",
        price: inputService,
        gstRate: 18,
        gstAmount: isGSTApplied ? inputService * 0.18 : 0,
        amount: isGSTApplied ? inputService * 1.18 : inputService
      });
    }

    return {
      repair: formattedRepairParts,
      service: formattedServiceParts
    };
  };

  const downloadChallanPDF = (invoice, itemsData, shouldSave = true, externalDoc = null) => {
    const doc = externalDoc || new jsPDF();
    const vendorName = batchData?.vendorName || invoice?.sellingPartner;
    const vendor = getVendorDetails(vendorName, modalClaimData?.ascState);
    const customerName = invoice?.customerName || "Customer";
    const aaNumber = invoice?.aA_Number || "";
    const imei = invoice?.imeiNumber || "";
    const device = `${invoice?.brand || ""} ${invoice?.makeModel || ""}`;
    const currentInvoiceNo = invoiceNo || `AA/CE/${invoice?.id || 1}`;
    const currentInvoiceDate = invoiceDate
      ? new Date(invoiceDate).toLocaleDateString('en-GB').replace(/\//g, '-')
      : new Date().toLocaleDateString('en-GB').replace(/\//g, '-');

    const customerAddress = modalClaimData?.address || "Address Not Found";
    const customerPincode = modalClaimData?.pincode || "";

    // 1. Header
    doc.setFont("Helvetica", "bold");
    doc.setFontSize(14);
    doc.text(vendor.name, 15, 20);

    doc.setFont("Helvetica", "normal");
    doc.setFontSize(9);
    doc.setTextColor(80, 80, 80);
    doc.text(vendor.address, 15, 25);
    doc.text(`Phone no. : ${vendor.phone}`, 15, 30);
    doc.text(`GSTIN : ${vendor.gstin}`, 15, 35);
    doc.text(`State: ${vendor.state}`, 15, 40);

    // Horizontal Line
    doc.setDrawColor(220, 220, 220);
    doc.setLineWidth(0.5);
    doc.line(15, 45, 195, 45);

    // 2. Title
    doc.setFont("Helvetica", "bold");
    doc.setFontSize(14);
    doc.setTextColor(114, 28, 36); // Maroon color
    doc.text("Challan", 105, 53, { align: "center" });

    // 3. Columns: To & Details
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(9);
    doc.setFont("Helvetica", "bold");
    doc.text("To", 15, 62);
    doc.text("Across Assist Pvt Ltd c/o " + customerName + " (" + aaNumber + ")", 15, 67);

    doc.setFont("Helvetica", "normal");
    const addrLines = doc.splitTextToSize(customerAddress + (customerPincode ? `\nPin Code - ${customerPincode}` : "") + "\nGST IN: 06AAHCB4822B1Z6", 90);
    doc.text(addrLines, 15, 72);

    // Right Column
    doc.setFont("Helvetica", "bold");
    doc.text("Challan Details", 130, 62);
    doc.setFont("Helvetica", "normal");
    doc.text(`No. : ${currentInvoiceNo}`, 130, 67);
    doc.text(`Date : ${currentInvoiceDate}`, 130, 72);

    // 4. Table Rows
    const tableBody = itemsData.map((item, idx) => [
      idx + 1,
      item.name,
      item.quantity,
      item.unit,
      "Rs. " + parseFloat(item.price).toFixed(2),
      "Rs. " + parseFloat(item.price * item.quantity).toFixed(2)
    ]);

    const totalQty = itemsData.reduce((sum, item) => sum + item.quantity, 0);
    const subTotal = itemsData.reduce((sum, item) => sum + (item.price * item.quantity), 0);
    const totalWithGST = subTotal; // Challan does not have GST

    // Add total row
    tableBody.push([
      { content: "Total", colSpan: 2, styles: { fontStyle: "bold", halign: "left" } },
      { content: totalQty.toString(), styles: { fontStyle: "bold", halign: "center" } },
      "",
      "",
      { content: "Rs. " + totalWithGST.toFixed(2), styles: { fontStyle: "bold", halign: "right" } }
    ]);

    // Draw Table
    autoTable(doc, {
      startY: 95,
      head: [["#", "Item name", "Quantity", "Unit", "Price/ Unit", "Amount"]],
      body: tableBody,
      theme: "grid",
      headStyles: {
        fillColor: [92, 37, 24],
        textColor: [255, 255, 255],
        fontStyle: "bold",
        fontSize: 8,
        halign: "center"
      },
      columnStyles: {
        0: { halign: "center", cellWidth: 10 },
        1: { halign: "left", cellWidth: 80 },
        2: { halign: "center", cellWidth: 20 },
        3: { halign: "center", cellWidth: 20 },
        4: { halign: "right", cellWidth: 25 },
        5: { halign: "right", cellWidth: 25 }
      },
      styles: {
        fontSize: 8,
        cellPadding: 3
      },
      didParseCell: function (data) {
        if (data.row.index === tableBody.length - 1) {
          data.cell.styles.fillColor = [245, 245, 245];
        }
      }
    });

    const finalY = doc.lastAutoTable.finalY + 10;

    // 5. Bottom Sections: Left (Description, Words, Terms) and Right (Totals box)
    let currY = finalY;
    doc.setFont("Helvetica", "bold");
    doc.text("Description", 15, currY);
    doc.setFont("Helvetica", "normal");
    currY += 5;
    doc.text(`Repair support for ${device}`, 15, currY);
    doc.text(`IMEI: ${imei}`, 15, currY + 4);

    doc.setFont("Helvetica", "bold");
    doc.text("Amount In Words", 15, currY + 12);
    doc.setFont("Helvetica", "normal");
    const roundedTotal = Math.round(totalWithGST);
    doc.text(numberToWords(roundedTotal), 15, currY + 17);

    doc.setFont("Helvetica", "bold");
    doc.text("Terms and Conditions", 15, currY + 25);
    doc.setFont("Helvetica", "normal");
    doc.text("1. E.&O.E.", 15, currY + 30);

    // Right Section: Summary Box
    const boxX = 125;
    const boxWidth = 70;
    let boxY = finalY;

    // Subtotal Row
    doc.rect(boxX, boxY, boxWidth, 7);
    doc.setFont("Helvetica", "normal");
    doc.text("Sub Total", boxX + 5, boxY + 5);
    doc.text("Rs. " + subTotal.toFixed(2), boxX + boxWidth - 5, boxY + 5, { align: "right" });
    boxY += 7;

    // Roundoff Row
    const roundOffVal = roundedTotal - totalWithGST;
    doc.rect(boxX, boxY, boxWidth, 7);
    doc.text("Round off", boxX + 5, boxY + 5);
    doc.text((roundOffVal >= 0 ? "+ " : "- ") + "Rs. " + Math.abs(roundOffVal).toFixed(2), boxX + boxWidth - 5, boxY + 5, { align: "right" });
    boxY += 7;

    // Total Row (Maroon Banner)
    doc.setFillColor(92, 37, 24);
    doc.rect(boxX, boxY, boxWidth, 8, "F");
    doc.setTextColor(255, 255, 255);
    doc.setFont("Helvetica", "bold");
    doc.text("Total", boxX + 5, boxY + 5.5);
    doc.text("Rs. " + roundedTotal.toFixed(2), boxX + boxWidth - 5, boxY + 5.5, { align: "right" });

    // Reset Text Color
    doc.setTextColor(0, 0, 0);

    // Signature Area
    let sigY = boxY + 18;
    doc.setFont("Helvetica", "normal");
    doc.setFontSize(8);
    doc.text(`For : ${vendor.name}`, boxX + 5, sigY);

    // Draw Stamp
    const stampX = boxX + boxWidth / 2 - 10;
    const stampY = sigY + 12;
    doc.setDrawColor(0, 51, 153);
    doc.setLineWidth(0.8);
    doc.circle(stampX, stampY, 12);

    doc.setTextColor(0, 51, 153);
    doc.setFontSize(5);
    doc.setFont("Helvetica", "bold");
    doc.text("CHITRANSH", stampX, stampY - 3, { align: "center" });

    doc.setFontSize(7);
    doc.setFont("Helvetica", "oblique");
    doc.text("Honey", stampX, stampY + 1, { align: "center" });

    doc.setFontSize(5);
    doc.setFont("Helvetica", "bold");
    doc.text("ENTERPRISES", stampX, stampY + 5, { align: "center" });

    doc.setTextColor(0, 0, 0);
    doc.setFontSize(8);
    doc.setFont("Helvetica", "bold");
    doc.text("Authorized Signatory", boxX + 5, sigY + 28);

    if (shouldSave) {
      doc.save(`Challan_${aaNumber}.pdf`);
    }
    return doc;
  };

  const downloadInvoicePDF = (invoice, itemsData, shouldSave = true, externalDoc = null) => {
    const doc = externalDoc || new jsPDF();
    const vendorName = batchData?.vendorName || invoice?.sellingPartner;
    const vendor = getVendorDetails(vendorName, modalClaimData?.ascState);
    const customerName = invoice?.customerName || "Customer";
    const aaNumber = invoice?.aA_Number || "";
    const imei = invoice?.imeiNumber || "";
    const device = `${invoice?.brand || ""} ${invoice?.makeModel || ""}`;
    const currentInvoiceNo = invoiceNo || `AA/CE/${invoice?.id || 1}`;
    const currentInvoiceDate = invoiceDate
      ? new Date(invoiceDate).toLocaleDateString('en-GB').replace(/\//g, '-')
      : new Date().toLocaleDateString('en-GB').replace(/\//g, '-');

    const customerAddress = modalClaimData?.address || "Address Not Found";
    const customerPincode = modalClaimData?.pincode || "";

    // 1. Header
    doc.setFont("Helvetica", "bold");
    doc.setFontSize(14);
    doc.text(vendor.name, 15, 20);

    doc.setFont("Helvetica", "normal");
    doc.setFontSize(9);
    doc.setTextColor(80, 80, 80);
    doc.text(vendor.address, 15, 25);
    doc.text(`Phone no. : ${vendor.phone}`, 15, 30);
    doc.text(`GSTIN : ${vendor.gstin}`, 15, 35);
    doc.text(`State: ${vendor.state}`, 15, 40);

    // Horizontal Line
    doc.setDrawColor(220, 220, 220);
    doc.setLineWidth(0.5);
    doc.line(15, 45, 195, 45);

    // 2. Title
    doc.setFont("Helvetica", "bold");
    doc.setFontSize(14);
    doc.setTextColor(114, 28, 36); // Maroon color
    doc.text("Tax Invoice", 105, 53, { align: "center" });

    // 3. Columns: To & Details
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(9);
    doc.setFont("Helvetica", "bold");
    doc.text("Bill To", 15, 62);
    doc.text("Across Assist Pvt Ltd c/o " + customerName + " (" + aaNumber + ")", 15, 67);

    doc.setFont("Helvetica", "normal");
    const addrLines = doc.splitTextToSize(customerAddress + (customerPincode ? `\nPin Code - ${customerPincode}` : "") + "\nGST IN: 06AAHCB4822B1Z6", 90);
    doc.text(addrLines, 15, 72);

    // Right Column
    doc.setFont("Helvetica", "bold");
    doc.text("Invoice Details", 130, 62);
    doc.setFont("Helvetica", "normal");
    doc.text(`No. : ${currentInvoiceNo}`, 130, 67);
    doc.text(`Date : ${currentInvoiceDate}`, 130, 72);

    // 4. Table Rows
    const tableBody = itemsData.map((item, idx) => [
      idx + 1,
      item.name,
      item.quantity,
      item.unit,
      "Rs. " + parseFloat(item.price).toFixed(2),
      `Rs. ${parseFloat(item.gstAmount).toFixed(2)} (${item.gstRate}%)`,
      "Rs. " + parseFloat(item.amount).toFixed(2)
    ]);

    const totalQty = itemsData.reduce((sum, item) => sum + item.quantity, 0);
    const subTotal = itemsData.reduce((sum, item) => sum + (item.price * item.quantity), 0);
    const totalGst = itemsData.reduce((sum, item) => sum + item.gstAmount, 0);
    const totalWithGST = itemsData.reduce((sum, item) => sum + item.amount, 0);

    // Add total row
    tableBody.push([
      { content: "Total", colSpan: 2, styles: { fontStyle: "bold", halign: "left" } },
      { content: totalQty.toString(), styles: { fontStyle: "bold", halign: "center" } },
      "",
      "",
      "",
      { content: "Rs. " + totalWithGST.toFixed(2), styles: { fontStyle: "bold", halign: "right" } }
    ]);

    // Draw Table
    autoTable(doc, {
      startY: 95,
      head: [["#", "Item name", "Quantity", "Unit", "Price/ Unit", "GST", "Amount"]],
      body: tableBody,
      theme: "grid",
      headStyles: {
        fillColor: [92, 37, 24],
        textColor: [255, 255, 255],
        fontStyle: "bold",
        fontSize: 8,
        halign: "center"
      },
      columnStyles: {
        0: { halign: "center", cellWidth: 10 },
        1: { halign: "left", cellWidth: 70 },
        2: { halign: "center", cellWidth: 20 },
        3: { halign: "center", cellWidth: 15 },
        4: { halign: "right", cellWidth: 22 },
        5: { halign: "center", cellWidth: 26 },
        6: { halign: "right", cellWidth: 22 }
      },
      styles: {
        fontSize: 8,
        cellPadding: 3
      },
      didParseCell: function (data) {
        if (data.row.index === tableBody.length - 1) {
          data.cell.styles.fillColor = [245, 245, 245];
        }
      }
    });

    const finalY = doc.lastAutoTable.finalY + 10;

    // 5. Bottom Sections
    let currY = finalY;
    doc.setFont("Helvetica", "bold");
    doc.text("Description", 15, currY);
    doc.setFont("Helvetica", "normal");
    currY += 5;
    doc.text(`Repair support for ${device}`, 15, currY);
    doc.text(`IMEI: ${imei}`, 15, currY + 4);

    doc.setFont("Helvetica", "bold");
    doc.text("Amount In Words", 15, currY + 12);
    doc.setFont("Helvetica", "normal");
    const roundedTotal = Math.round(totalWithGST);
    doc.text(numberToWords(roundedTotal), 15, currY + 17);

    doc.setFont("Helvetica", "bold");
    doc.text("Terms and Conditions", 15, currY + 25);
    doc.setFont("Helvetica", "normal");
    doc.text("1. E.&O.E.", 15, currY + 30);

    // Right Section: Summary Box
    const boxX = 125;
    const boxWidth = 70;
    let boxY = finalY;

    // Subtotal Row
    doc.rect(boxX, boxY, boxWidth, 7);
    doc.setFont("Helvetica", "normal");
    doc.text("Sub Total", boxX + 5, boxY + 5);
    doc.text("Rs. " + subTotal.toFixed(2), boxX + boxWidth - 5, boxY + 5, { align: "right" });
    boxY += 7;

    // IGST Row
    doc.rect(boxX, boxY, boxWidth, 7);
    doc.text(`IGST@18%`, boxX + 5, boxY + 5);
    doc.text("Rs. " + totalGst.toFixed(2), boxX + boxWidth - 5, boxY + 5, { align: "right" });
    boxY += 7;

    // Roundoff Row
    const roundOffVal = roundedTotal - totalWithGST;
    doc.rect(boxX, boxY, boxWidth, 7);
    doc.text("Round off", boxX + 5, boxY + 5);
    doc.text((roundOffVal >= 0 ? "+ " : "- ") + "Rs. " + Math.abs(roundOffVal).toFixed(2), boxX + boxWidth - 5, boxY + 5, { align: "right" });
    boxY += 7;

    // Total Row (Maroon Banner)
    doc.setFillColor(92, 37, 24);
    doc.rect(boxX, boxY, boxWidth, 8, "F");
    doc.setTextColor(255, 255, 255);
    doc.setFont("Helvetica", "bold");
    doc.text("Total", boxX + 5, boxY + 5.5);
    doc.text("Rs. " + roundedTotal.toFixed(2), boxX + boxWidth - 5, boxY + 5.5, { align: "right" });

    // Received Row
    boxY += 8;
    doc.setTextColor(0, 0, 0);
    doc.setFont("Helvetica", "normal");
    doc.rect(boxX, boxY, boxWidth, 7);
    doc.text("Received", boxX + 5, boxY + 5);
    doc.text("Rs. 0.00", boxX + boxWidth - 5, boxY + 5, { align: "right" });
    boxY += 7;

    // Balance Row
    doc.rect(boxX, boxY, boxWidth, 7);
    doc.text("Balance", boxX + 5, boxY + 5);
    doc.text("Rs. " + roundedTotal.toFixed(2), boxX + boxWidth - 5, boxY + 5, { align: "right" });

    // Signature Area
    let sigY = boxY + 18;
    doc.setFont("Helvetica", "normal");
    doc.setFontSize(8);
    doc.text(`For : ${vendor.name}`, boxX + 5, sigY);

    // Draw Stamp
    const stampX = boxX + boxWidth / 2 - 10;
    const stampY = sigY + 12;
    doc.setDrawColor(0, 51, 153);
    doc.setLineWidth(0.8);
    doc.circle(stampX, stampY, 12);

    doc.setTextColor(0, 51, 153);
    doc.setFontSize(5);
    doc.setFont("Helvetica", "bold");
    doc.text("CHITRANSH", stampX, stampY - 3, { align: "center" });

    doc.setFontSize(7);
    doc.setFont("Helvetica", "oblique");
    doc.text("Honey", stampX, stampY + 1, { align: "center" });

    doc.setFontSize(5);
    doc.setFont("Helvetica", "bold");
    doc.text("ENTERPRISES", stampX, stampY + 5, { align: "center" });

    doc.setTextColor(0, 0, 0);
    doc.setFontSize(8);
    doc.setFont("Helvetica", "bold");
    doc.text("Authorized Signatory", boxX + 5, sigY + 28);

    if (shouldSave) {
      doc.save(`Invoice_${aaNumber}.pdf`);
    }
    return doc;
  };

  const renderDocumentPreview = () => {
    if (!editingInvoice) return null;

    const displayItems = getDisplayItems();
    const vendorName = batchData?.vendorName || editingInvoice?.sellingPartner;
    const vendor = getVendorDetails(vendorName, modalClaimData?.ascState);
    const currentInvoiceNo = invoiceNo || `AA/CE/${editingInvoice?.id || 1}`;
    const currentInvoiceDate = invoiceDate
      ? new Date(invoiceDate).toLocaleDateString('en-GB').replace(/\//g, '-')
      : new Date().toLocaleDateString('en-GB').replace(/\//g, '-');

    // Choose document type based on Billing Type and active preview tab
    let previewTitle = "Tax Invoice";
    let itemsToRender = [];
    let showGstCol = true;
    let isChallanDoc = false;

    if (editValues.billingType === "billing") {
      previewTitle = "Tax Invoice";
      itemsToRender = [...displayItems.repair, ...displayItems.service];
      showGstCol = true;
      isChallanDoc = false;
    } else {
      if (activePreviewTab === "challan") {
        previewTitle = "Challan";
        itemsToRender = displayItems.repair;
        showGstCol = false;
        isChallanDoc = true;
      } else {
        previewTitle = "Tax Invoice";
        itemsToRender = displayItems.service;
        showGstCol = true;
        isChallanDoc = false;
      }
    }

    const previewTotalQty = itemsToRender.reduce((sum, item) => sum + item.quantity, 0);
    const previewSubTotal = itemsToRender.reduce((sum, item) => sum + (item.price * item.quantity), 0);
    const previewTotalGst = isChallanDoc ? 0 : itemsToRender.reduce((sum, item) => sum + item.gstAmount, 0);
    const previewTotalWithGST = isChallanDoc ? previewSubTotal : itemsToRender.reduce((sum, item) => sum + item.amount, 0);
    const previewRoundedTotal = Math.round(previewTotalWithGST);
    const previewRoundOff = previewRoundedTotal - previewTotalWithGST;
    const previewAmountInWords = numberToWords(previewRoundedTotal);

    return (
      <div className="invoice-preview-container bg-white border rounded p-3 shadow-sm" style={{ fontSize: "11px", color: "#333", fontFamily: "Arial, sans-serif" }}>
        {/* Document Header */}
        <div className="d-flex justify-content-between align-items-start border-bottom pb-2 mb-2">
          <div>
            <h6 className="fw-bold m-0" style={{ fontSize: "14px", color: "#000" }}>{vendor.name}</h6>
            <div className="text-muted" style={{ fontSize: "10px", lineHeight: "1.3" }}>
              {vendor.address}<br />
              Phone no. : {vendor.phone}<br />
              GSTIN : {vendor.gstin}<br />
              State: {vendor.state}
            </div>
          </div>
        </div>

        {/* Title */}
        <div className="text-center my-2">
          <h6 className="fw-bold m-0" style={{ color: "#721c24", textTransform: "uppercase", letterSpacing: "1px", fontSize: "13px" }}>
            {previewTitle}
          </h6>
        </div>

        {/* To and Details */}
        <div className="row mb-3">
          <div className="col-7">
            <span className="fw-bold d-block text-dark" style={{ fontSize: "10px" }}>{isChallanDoc ? "To" : "Bill To"}</span>
            <span className="fw-bold text-dark d-block">
              Across Assist Pvt Ltd c/o {editingInvoice.customerName} ({editingInvoice.aA_Number})
            </span>
            <span className="text-muted d-block" style={{ lineHeight: "1.3" }}>
              {modalClaimData?.address || "Address Not Found"}<br />
              {modalClaimData?.pincode && `Pin Code - ${modalClaimData.pincode}`}<br />
              GST IN: 06AAHCB4822B1Z6
            </span>
          </div>
          <div className="col-5 text-end">
            <span className="fw-bold d-block text-dark" style={{ fontSize: "10px" }}>{isChallanDoc ? "Challan Details" : "Invoice Details"}</span>
            <span className="text-dark d-block">No. : <strong className="text-dark">{currentInvoiceNo}</strong></span>
            <span className="text-dark d-block">Date : {currentInvoiceDate}</span>
          </div>
        </div>

        {/* Table */}
        <div className="table-responsive mb-3">
          <table className="table table-bordered table-sm m-0 text-center" style={{ fontSize: "10px" }}>
            <thead>
              <tr style={{ backgroundColor: "#5C2518", color: "#ffffff" }}>
                <th style={{ width: "5%" }}>#</th>
                <th style={{ width: showGstCol ? "50%" : "65%", textAlign: "left" }}>Item name</th>
                <th style={{ width: "10%" }}>Qty</th>
                <th style={{ width: "10%" }}>Unit</th>
                <th style={{ width: "13%", textAlign: "right" }}>Price/ Unit</th>
                {showGstCol && <th style={{ width: "15%", textAlign: "right" }}>GST</th>}
                <th style={{ width: "12%", textAlign: "right" }}>Amount</th>
              </tr>
            </thead>
            <tbody>
              {itemsToRender.map((item, idx) => (
                <tr key={idx}>
                  <td>{idx + 1}</td>
                  <td style={{ textAlign: "left" }}>{item.name}</td>
                  <td>{item.quantity}</td>
                  <td>{item.unit}</td>
                  <td style={{ textAlign: "right" }}>₹{item.price.toFixed(2)}</td>
                  {showGstCol && (
                    <td style={{ textAlign: "right" }}>
                      ₹{item.gstAmount.toFixed(2)} <span className="text-muted" style={{ fontSize: "9px" }}>({item.gstRate}%)</span>
                    </td>
                  )}
                  <td style={{ textAlign: "right" }}>
                    ₹{(isChallanDoc ? item.price : item.amount).toFixed(2)}
                  </td>
                </tr>
              ))}
              {/* Total Row */}
              <tr className="fw-bold bg-light">
                <td colSpan="2" style={{ textAlign: "left" }}>Total</td>
                <td>{previewTotalQty}</td>
                <td></td>
                <td></td>
                {showGstCol && <td></td>}
                <td style={{ textAlign: "right" }}>₹{previewTotalWithGST.toFixed(2)}</td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Footer Summary Blocks */}
        <div className="row pt-2 border-top">
          {/* Left Block */}
          <div className="col-7">
            <div className="mb-2">
              <span className="fw-bold text-dark d-block">Description</span>
              <span className="text-muted d-block">
                Repair support for {editingInvoice.brand} {editingInvoice.makeModel}<br />
                IMEI: {editingInvoice.imeiNumber}
              </span>
            </div>
            <div className="mb-2">
              <span className="fw-bold text-dark d-block">Amount In Words</span>
              <span className="text-muted d-block fw-semibold text-wrap" style={{ fontSize: "9.5px" }}>
                {previewAmountInWords}
              </span>
            </div>
            <div>
              <span className="fw-bold text-dark d-block">Terms and Conditions</span>
              <span className="text-muted d-block">1. E.&O.E.</span>
            </div>
          </div>

          {/* Right Block */}
          <div className="col-5 text-end">
            <div className="border rounded mb-3 bg-light text-start">
              <div className="d-flex justify-content-between p-1 border-bottom">
                <span>Sub Total</span>
                <span>₹{previewSubTotal.toFixed(2)}</span>
              </div>
              {!isChallanDoc && (
                <div className="d-flex justify-content-between p-1 border-bottom">
                  <span>IGST@18%</span>
                  <span>₹{previewTotalGst.toFixed(2)}</span>
                </div>
              )}
              <div className="d-flex justify-content-between p-1 border-bottom">
                <span>Round off</span>
                <span>{previewRoundOff >= 0 ? "+" : ""}{previewRoundOff.toFixed(2)}</span>
              </div>
              <div className="d-flex justify-content-between p-1 fw-bold text-white" style={{ backgroundColor: "#5C2518" }}>
                <span>Total</span>
                <span>₹{previewRoundedTotal.toFixed(2)}</span>
              </div>
              {!isChallanDoc && (
                <>
                  <div className="d-flex justify-content-between p-1 border-bottom">
                    <span>Received</span>
                    <span>₹0.00</span>
                  </div>
                  <div className="d-flex justify-content-between p-1 fw-bold">
                    <span>Balance</span>
                    <span>₹{previewRoundedTotal.toFixed(2)}</span>
                  </div>
                </>
              )}
            </div>

            {/* Signature Area */}
            <div className="text-center pt-2 relative" style={{ minHeight: "100px" }}>
              <span className="text-muted d-block mb-1" style={{ fontSize: "9px" }}>For : {vendor.name}</span>

              <div
                className="d-inline-flex flex-column align-items-center justify-content-center rounded-circle border border-primary p-1"
                style={{
                  width: "56px",
                  height: "56px",
                  borderColor: "#003399",
                  borderStyle: "solid",
                  borderWidth: "1.5px",
                  transform: "rotate(-12deg)",
                  color: "#003399",
                  margin: "5px 0",
                  opacity: 0.85,
                  userSelect: "none"
                }}
              >
                <span style={{ fontSize: "5px", fontWeight: "bold" }}>CHITRANSH</span>
                <span style={{ fontSize: "9px", fontFamily: "cursive", fontWeight: "bold", fontStyle: "italic", margin: "-2px 0" }}>Honey</span>
                <span style={{ fontSize: "5px", fontWeight: "bold" }}>ENTERPRISES</span>
              </div>

              <span className="fw-bold text-dark d-block mt-2" style={{ fontSize: "9.5px" }}>Authorized Signatory</span>
            </div>
          </div>
        </div>
      </div>
    );
  };

  console.log("Batch No:", batchNo);
  console.log("Invoice Status:", invoiceStatus);
  console.log("Full Data:", batchData);

  const itemsPerPage = 10;
  const totalPages = Math.ceil(invoices.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentInvoices = invoices.slice(indexOfFirstItem, indexOfLastItem);
  const selectedAAno = invoices.filter((invoice) => invoice.isChecked);


  // Calculate totals based on selected invoices only
  const totalRepairCharges = selectedAAno.reduce((total, invoice) => {
    const cleanedAmount = invoice.repairCharges?.toString().replace(/,/g, "");
    const amount = parseFloat(cleanedAmount);
    return total + (isNaN(amount) ? 0 : amount);
  }, 0);

  const totalServiceCharges = selectedAAno.reduce((total, invoice) => {
    const cleanedAmount = invoice.serviceCharges?.toString().replace(/,/g, "");
    const amount = parseFloat(cleanedAmount);
    return total + (isNaN(amount) ? 0 : amount);
  }, 0);

  const grossAmount = selectedAAno.reduce((total, invoice) => {
    const cleanedAmount = invoice.total?.toString().replace(/,/g, "");
    const amount = parseFloat(cleanedAmount);
    return total + (isNaN(amount) ? 0 : amount);
  }, 0);

  const gstAmount = isGSTApplied
    ? (totalServiceCharges * 0.18).toFixed(2)
    : (0).toFixed(2);
  const totalservicechargewithGST = (
    totalServiceCharges + parseFloat(gstAmount)
  ).toFixed(2);
  console.log(totalservicechargewithGST, 'total servicee ')

  const finalAmount = (
    totalRepairCharges +
    totalServiceCharges +
    parseFloat(gstAmount)
  ).toFixed(2);

  useEffect(() => {
    if (!batchData) {
      navigate("/invoice");
      return;
    }
    setCaseCount(batchData.caseCount || "");

    if (!batchData.gst || batchData.gst === "0.00") {
      setIsGSTApplied(false);
    } else {
      setIsGSTApplied(true);
    }
    setInvoiceNo(batchData.invoiceNo || "");
    setInvoiceDate(batchData.invoiceDate || "");
    setInvoiceAmount(batchData.invoiceAmount || "");
    if (batchData.invoice) {
      const fileName = batchData.invoice.split("/").pop() || "invoice.pdf";
      const fileType = fileName.split(".").pop()?.toLowerCase() || "";
      setExistingInvoice({
        url: batchData.invoice,
        fileName: fileName,
        fileType: fileType,
      });
      setFileType(fileType);
    }
  }, [batchData, navigate]);

  useEffect(() => {
    if (!batchData) return;
    setLoading(true);
    if (batchData.aaNo) {
      const aaNumbers = batchData.aaNo.split(",").map((val) => val.trim());
      Promise.all(
        aaNumbers.map((aaNo) =>
          fetch(`${BASE_URL}/GetGadgetCaseDetailsByAA?aaNumbers=${aaNo}`)
            .then((response) => {
              if (!response.ok) {
                console.error(
                  `HTTP error for aaNo ${aaNo}: ${response.status}`
                );
                return { status: false, aA_Number: aaNo, dataItems: [] };
              }
              return response.json();
            })
            .then((responseData) => {
              if (!responseData || responseData.status === false) {
                return { status: false, aA_Number: aaNo, dataItems: [] };
              }
              const remarkFileUrl =
                responseData?.dataItems?.[0]?.remarkFileUrl || null;
              const remarks =
                responseData?.dataItems?.[0]?.remarks || null;
              const documentFileUrl =
                responseData?.dataItems?.[0]?.documentFileUrl || null;
              const billingType =
                responseData?.dataItems?.[0]?.billingType || null;
                const invoiceStatus =
                responseData?.dataItems?.[0]?.invoiceStatus || null;
              return {
                status: responseData.status,
                aA_Number: aaNo,
                dataItems: Array.isArray(responseData.dataItems)
                  ? responseData.dataItems
                  : [],
                remarkFileUrl, remarks, documentFileUrl, billingType,invoiceStatus
              };

            })
            .catch((error) => {
              console.error(`Error fetching API data for ${aaNo}:`, error);
              return { status: false, aA_Number: aaNo, dataItems: [] };
            })
        )
      )
        .then((results) => {
          setApiData(results.filter((item) => item));
        })
        .catch((error) => {
          console.error("Error in Promise.all:", error);
          setApiData([]);
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, [batchData]);

  useEffect(() => {
    if (!batchData) return;
    if (loading) return;
    if (!apiData || apiData.length === 0) return;

    const splitData = (key) =>
      batchData[key]
        ?.split(",")
        .map((val) => (val === "NULL" ? "-" : val.trim())) || [];

    const remainAAArray = splitData("remainAA");
    const utrArray = splitData("utr");
    const utrMap = {};
    remainAAArray.forEach((aa, i) => {
      if (aa && aa !== "-") utrMap[aa] = utrArray[i] || "-";
    });

    const invoicesArray = splitData("aaNo").map((_, i) => ({
      aA_Number: splitData("aaNo")[i],
      imeiNumber: splitData("imeiNo")[i],
      creationDate: batchData.creationDate || "",
      closureDate: batchData.closureDate || "",
      customerName: splitData("customerName")[i],
      serviceType: splitData("serviceType")[i],
      brand: splitData("brand")[i],
      makeModel: splitData("makeModel")[i],
      repairCharges: parseFloat(splitData("repairCharges")[i] || "0").toFixed(2),
      serviceCharges: parseFloat(splitData("serviceCharges")[i] || "0").toFixed(2),
      chargesInclGST: parseFloat(splitData("chargesInclGST")[i] || "0").toFixed(2),
      total: parseFloat(splitData("total")[i] || "0").toFixed(2),
      invoiceStatus: batchData.invoiceStatus || "-",
      sellingPartner: splitData("sellingPartner")[i],
      networkAndFinanceStatus: splitData("networkAndFinanceStatus")[i],
      batchNo: batchData.batchNo || "",
      uniquePending: batchData.uniquePending || "",
      isChecked: true,
      remarks: splitData("remarks")[i] || "",
      remarkFileUrl: null,
      documentFileUrl: null,
      billingType: "billing",
      utrNo: utrMap[splitData("aaNo")[i]] || "-",
    }));

    const storedInvoices = JSON.parse(localStorage.getItem("invoices") || "[]");
    const mergedWithLocal = invoicesArray.map((invoice) => {
      const stored = storedInvoices.find((item) => item.aA_Number === invoice.aA_Number);
      return stored
        ? {
          ...invoice,
          ...stored,
          remarks: stored.remarks || invoice.remarks,
          remarkFileUrl: stored.remarkFile || invoice.remarkFileUrl,
          billingType: stored.billingType || invoice.billingType,
          documentFileUrl: stored.documentFileUrl || invoice.documentFileUrl,
        }
        : invoice;
    });

    // FIX: Preserve batch data for charges and only update remarks/files from API
    const mergedWithApi = mergedWithLocal.map((invoice) => {
      const apiMatch = apiData.find((item) => item.aA_Number === invoice.aA_Number);
      if (!apiMatch) return invoice;
      const system = apiMatch.dataItems?.[0] || {};

      return {
        ...invoice,
        // Keep batch data for charges and other fields
        serviceCharges: invoice.serviceCharges, // Preserve batch service charges
        repairCharges: invoice.repairCharges,   // Preserve batch repair charges
        total: invoice.total,                   // Preserve batch total
        serviceType: invoice.serviceType,       // Preserve batch service type
        imeiNumber: invoice.imeiNumber,         // Preserve batch IMEI
        // Only update remarks and files from API
         invoiceStatus: system.invoiceStatus || apiMatch.invoiceStatus || invoice.invoiceStatus,
        remarks: system.remarks || apiMatch.remarks || invoice.remarks,
        remarkFileUrl: system.remarkFileUrl || apiMatch.remarkFileUrl || invoice.remarkFileUrl,
        documentFileUrl: system.documentFileUrl || apiMatch.documentFileUrl || invoice.documentFileUrl,
        billingType: system.billingType || apiMatch.billingType || invoice.billingType,
      };
    });

    setInvoices(mergedWithApi);
  }, [batchData, apiData, loading]);
  const normalize = (value) =>
    (value ? value.toString().trim() : "").toLowerCase();

  const getRowClassName = useCallback(
    (invoice) => {
      if (!Array.isArray(apiData) || apiData.length === 0) return "row-red";
      const matchedData = apiData.find(
        (item) => item.aA_Number === invoice.aA_Number
      );
      if (!matchedData || matchedData.status === false) return "row-red";
      if (
        matchedData.status === true &&
        Array.isArray(matchedData.dataItems) &&
        matchedData.dataItems.length > 0
      ) {
        const dataItem = matchedData.dataItems[0];
        if (
          normalize(dataItem.serviceType) !== normalize(invoice.serviceType) ||
          normalize(dataItem.repairCharges) !==
          normalize(invoice.repairCharges) ||
          normalize(dataItem.serviceCharges) !==
          normalize(invoice.serviceCharges) ||
          normalize(dataItem.total) !== normalize(invoice.total) ||
          normalize(dataItem.imeiNumber) !== normalize(invoice.imeiNumber)
        ) {
          return "row-yellow";
        }
        return "row-green";
      }
      return "row-red";
    },
    [apiData]
  );
  const getDifferencesData = (invoice) => {
    const matchedData = apiData.find(
      (item) => item.aA_Number === invoice.aA_Number
    );
    if (!matchedData || matchedData.status === false)
      return [{ field: "AA Number", table: invoice.aA_Number, api: "" }];
    const dataItem = matchedData.dataItems[0] || {};
    const differences = [];

    // if (normalize(dataItem.serviceType) !== normalize(invoice.serviceType)) {
    //   differences.push({
    //     field: "Service Type",
    //     table: invoice.serviceType || "",
    //     api: dataItem.serviceType || "",
    //   });
    // }
    if (normalize(dataItem.imeiNumber) !== normalize(invoice.imeiNumber)) {
      differences.push({
        field: "IMEI Number",
        table: invoice.imeiNumber || "",
        api: dataItem.imeiNumber || "",
      });
    }
    if (
      normalize(dataItem.repairCharges) !== normalize(invoice.repairCharges)
    ) {
      differences.push({
        field: "Repair Charges",
        table: invoice.repairCharges || "",
        api: dataItem.repairCharges || "",
      });
    }
    if (
      normalize(dataItem.serviceCharges) !== normalize(invoice.serviceCharges)
    ) {
      differences.push({
        field: "Service Charges",
        table: invoice.serviceCharges || "",
        api: dataItem.serviceCharges || "",
      });
    }
    if (normalize(dataItem.total) !== normalize(invoice.total)) {
      differences.push({
        field: "Total Amount",
        table: invoice.total || "",
        api: dataItem.total || "",
      });
    }
    return differences.length > 0 ? differences : [];
  };
  const [rowDeleted, setRowDeleted] = useState(false);
  const handleDelete = async (aANumber) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        // Step 1: Ask for Remark Input
        const { value: remark } = await Swal.fire({
          title: "Add Remark",
          input: "textarea",
          inputLabel: "Please enter your remark before deleting:",
          inputPlaceholder: "Enter remark here...",
          inputAttributes: { "aria-label": "Type your remark here" },
          showCancelButton: true,
          confirmButtonText: "Save Remark",
        });

        if (!remark) {
          Swal.fire("Cancelled", "Remark is required to proceed.", "info");
          return;
        }

        try {
          // const remarkFormData = new FormData();
          const allAANumbers = invoices.map((inv) => inv.aA_Number).join(",");

          const formData = new FormData();

          formData.append("aA_Number", allAANumbers);
          formData.append("remarks", `AANumber-${aANumber} Deleted: ${remark}`);
          formData.append("remarkAndLogBy", user.role);
          formData.append("batchNo", batchData.batchNo);
          formData.append("DeletedAA", aANumber);
          formData.append("logs", `AANumber-${aANumber} Deleted from ${batchData.batchNo} `);

          const res = await fetch(`${BASE_URL}/InsertLogsAndRemarksTracking`, {
            method: "POST",
            body: formData,
          });

          if (!res.ok) {
            throw new Error("Failed to save remark");
          }

          // Step 3: Call Delete API after remark success
          const deleteResponse = await fetch(`${BASE_URL}/ResetGadgetCaseDetails`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ aA_Number: aANumber }),
          });

          const data = await deleteResponse.json();

          if (deleteResponse.ok) {
            const updatedInvoices = invoices.filter((invoice) => invoice.aA_Number !== aANumber);
            setInvoices(updatedInvoices);
            setRowDeleted(true)

            Swal.fire("Deleted!", "Your record has been deleted.", "success");

            if (updatedInvoices.length === 0) {
              navigate("/invoice");
            }
          } else {
            Swal.fire("Error!", data.message || "Failed to delete record.", "error");
          }
        } catch (error) {
          console.error("Error:", error);
          Swal.fire("Error!", "Something went wrong. Please try again.", "error");
        }
      }
    });
  };
  const handleViewClick = (aaNumber) => {
    sessionStorage.setItem('preserveInvoices', 'true');
    navigate("/invoice-template", { state: { aaNumber } });
  };

  const handleBackClick = () => {
    localStorage.removeItem("invoices");
    navigate(-1);
  };
  useEffect(() => {
    return () => {
      if (sessionStorage.getItem('preserveInvoices') !== 'true') {
        localStorage.removeItem("invoices");
      }
      sessionStorage.removeItem('preserveInvoices');
    };
  }, []);
  // handle submit remark + delete
  const handleRemarkSubmit = async () => {
    try {
      const editingInvoice = invoices[selectedInvoiceIndex];
      const remarkFormData = new FormData();
      remarkFormData.append("AANo", editingInvoice.aA_Number);
      remarkFormData.append("Remark", `${editingInvoice.aA_Number} - ${remarks}`);
      remarkFormData.append("BatchNo", batchData.batchNo);
      remarkFormData.append("ByWhom", user?.role || "");

      if (remarkFile instanceof File) {
        remarkFormData.append("RemarkFile", remarkFile, remarkFile.name);
      }

      const response = await fetch(`${BASE_URL}/UpdateRemarkAgainstBatch`, {
        method: "POST",
        body: remarkFormData,
      });

      const result = await response.json();
      if (!response.ok) {
        throw new Error(result.message || "Failed to update batch remarks.");
      }

      const updatedInvoices = invoices.filter((_, i) => i !== selectedInvoiceIndex);
      setInvoices(updatedInvoices);
      setRowDeleted(true)
      Swal.fire("Deleted!", "Selected records have been deleted.", "success");

      // if (updatedInvoices.length === 0) {
      //   navigate("/");
      // }

      // reset modal fields
      setOpenRemarkModal(false);
      setRemarks("");
      setRemarkFile(null);
    } catch (error) {
      console.error("Error updating batch remarks:", error);
      toast.error(`Failed to update batch remarks: ${error.message}`);
    }
  };
  const handleCheckboxChange = (invoiceId) => {
    setInvoices((prevInvoices) => {
      if (invoiceId === "all") {
        const allChecked = prevInvoices.every((invoice) => invoice.isChecked);
        return prevInvoices.map((invoice) => ({
          ...invoice,
          isChecked: !allChecked,
        }));
      }
      return prevInvoices.map((invoice) =>
        invoice.aA_Number === invoiceId
          ? { ...invoice, isChecked: !invoice.isChecked }
          : invoice
      );
    });
  };
  const hasAnySelected = invoices.some(inv => inv.isChecked);
  const handleClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const extension = file.name.split(".").pop().toLowerCase();
    if (
      existingInvoice.fileName &&
      file.name.toLowerCase() === existingInvoice.fileName.toLowerCase()
    ) {
      toast.error("This file is already associated with the invoice.");
      fileInputRef.current.value = "";
      return;
    }
    setFileType(extension);
    setUploadedFile(file);
    setFieldErrors((prev) => ({ ...prev, invoiceFile: false }));
    if (extension === "csv") {
      Papa.parse(file, {
        header: true,
        complete: (results) => {
          const row = results.data[0];
          setInvoiceNo(row["Invoice No"] || "");
          setInvoiceDate(row["Invoice Date"] || "");
          setInvoiceAmount(row["Invoice Amount"] || "");
          setCaseCount(row["Case Count"] || caseCount);
        },
        error: (err) => {
          console.error("CSV parsing error:", err);
          toast.error("Failed to read CSV file.");
        },
      });
    }
  };

  const handleEditInputChange = (e) => {
    const { name, value } = e.target;
    setEditValues((prev) => ({ ...prev, [name]: value }));
    if (name === "remarks" && editingInvoice) {
      setFieldErrors((prev) => ({
        ...prev,
        remarks: { ...prev.remarks, [editingInvoice.aA_Number]: !value.trim() },
      }));
    }
  };

  const handleRemarkFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setEditValues((prev) => ({ ...prev, remarkFile: file }));
    }
  };

  const handleCloseModal = () => {
    setShowEditModal(false);
    setEditingInvoice(null);
    setEditValues({
      serviceCharges: "",
      repairCharges: "",
      chargesInclGST: "",
      remarks: "",
      remarkFile: null,
      billingType: "billing",
      fileName: "",
    });
    setModalClaimData(null);
    setActivePreviewTab("challan");
    setShowPreview(false);
    if (editingInvoice) {
      setFieldErrors((prev) => ({
        ...prev,
        remarks: { ...prev.remarks, [editingInvoice.aA_Number]: false },
      }));
    }
  };

  const handleModalFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setEditValues((prev) => ({
        ...prev,
        remarkFile: file,
        fileName: file.name,
      }));
    }
  };

  const handleSaveEdit = async (aA_Number) => {
    const parsedServiceCharges = parseFloat(editValues.serviceCharges);
    const parsedRepairCharges = parseFloat(editValues.repairCharges);
    const parsedChargesInclGST = parseFloat(editValues.chargesInclGST);
    const remarks = editValues.remarks?.trim() || "";

    if (getDifferencesData(editingInvoice).length > 0 && !remarks) {
      setFieldErrors((prev) => ({
        ...prev,
        remarks: { ...prev.remarks, [aA_Number]: true },
      }));
      toast.error("Cannot proceed without a reason for mismatched data.");
      return;
    }

    const formattedServiceCharges = isNaN(parsedServiceCharges)
      ? "0.00"
      : parsedServiceCharges.toFixed(2);
    const formattedRepairCharges = isNaN(parsedRepairCharges)
      ? "0.00"
      : parsedRepairCharges.toFixed(2);
    const formattedChargesInclGST = isNaN(parsedChargesInclGST)
      ? "0.00"
      : parsedChargesInclGST.toFixed(2);
    const formattedTotal = (
      (isNaN(parsedServiceCharges) ? 0 : parsedServiceCharges) +
      (isNaN(parsedRepairCharges) ? 0 : parsedRepairCharges) +
      (isNaN(parsedChargesInclGST) ? 0 : parsedChargesInclGST)
    ).toFixed(2);

    try {
      const formData = new FormData();
      formData.append("aano", editingInvoice?.aA_Number);
      formData.append("remark", `${editingInvoice.aA_Number}: ${remarks}`);
      if (editValues.remarkFile instanceof File) {
        formData.append("remarkFile", editValues.remarkFile, editValues.remarkFile.name);
      } else {
        formData.append("remarkFile", null);
      }
      formData.append("RemarkBy", user.role);

      // Generate selected PDF document as Blob
      let pdfDoc;
      let docName;
      if (editValues.billingType === "billing") {
        pdfDoc = downloadInvoicePDF(editingInvoice, [...getDisplayItems().repair, ...getDisplayItems().service], false);
        docName = `Invoice_${editingInvoice.aA_Number}.pdf`;
      } else {
        pdfDoc = new jsPDF();
        downloadChallanPDF(editingInvoice, getDisplayItems().repair, false, pdfDoc);
        pdfDoc.addPage();
        downloadInvoicePDF(editingInvoice, getDisplayItems().service, false, pdfDoc);
        docName = `Challan_Invoice_${editingInvoice.aA_Number}.pdf`;
      }
      const pdfBlob = pdfDoc.output('blob');

      formData.append("BillingType", editValues.billingType);
      formData.append("Document", pdfBlob, docName);

      const response = await fetch(`${BASE_URL}/UpdateClaimRemarks`, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (data.status) {
        toast.success("Remark updated successfully.");

        const refreshResponse = await fetch(
          `${BASE_URL}/GetGadgetCaseDetailsByAA?aaNumbers=${editingInvoice.aA_Number}`
        );

        if (refreshResponse.ok) {
          const refreshedData = await refreshResponse.json();

          if (refreshedData.dataItems && refreshedData.dataItems.length > 0) {
            const updatedApiItem = refreshedData.dataItems[0];

            setApiData((prev) => {
              const updated = prev.map((item) =>
                item.aA_Number === editingInvoice.aA_Number
                  ? {
                    ...item,
                    ...updatedApiItem,
                    remarkFileUrl: updatedApiItem.remarkFileUrl || null,
                    documentFileUrl: updatedApiItem.documentFileUrl || null,
                    billingType: updatedApiItem.billingType || null,
                  }
                  : item
              );
              return updated;
            });

            setInvoices((prevInvoices) => {
              const updated = prevInvoices.map((invoice) =>
                invoice.aA_Number === editingInvoice.aA_Number
                  ? {
                    ...invoice,
                    serviceCharges: formattedServiceCharges,
                    repairCharges: formattedRepairCharges,
                    chargesInclGST: formattedChargesInclGST,
                    total: formattedTotal,
                    remarks: updatedApiItem.remarks || remarks,
                    billingType: editValues.billingType,
                    isEdited: true,
                    remarkFile: editValues.remarkFile instanceof File ? editValues.remarkFile : null,
                    remarkFileUrl: updatedApiItem.remarkFileUrl || null,
                    documentFileUrl: updatedApiItem.documentFileUrl || null,
                  }
                  : invoice
              );
              localStorage.setItem("invoices", JSON.stringify(updated));
              return updated;
            });
          }
        }

        handleCloseModal();
      } else {
        toast.error("Failed to update: " + (data.message || "Unknown error"));
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("Network error: " + error.message);
    }
  };

  const handleEdit = async (invoice) => {
    setEditingInvoice(invoice);
    setEditValues({
      serviceCharges: invoice.serviceCharges || "0.00",
      repairCharges: invoice.repairCharges || "0.00",
      chargesInclGST: invoice.chargesInclGST || "0.00",
      remarks: invoice.remarks || "",
      remarkFile: invoice.remarkFile instanceof File ? invoice.remarkFile : null,
      fileName: invoice.remarkFile && typeof invoice.remarkFile === "object"
        ? invoice.remarkFile.name
        : (invoice.remarkFileUrl || invoice.remarkFile || ""),
      billingType: invoice.billingType && invoice.billingType !== "-" ? invoice.billingType : "billing",
    });
    setModalClaimData(null);
    setActivePreviewTab("challan");
    setShowEditModal(true);

    try {
      const response = await fetch(`${BASE_URL}/GetAllGadgetClaimDetails?aaNumber=${invoice.aA_Number}`);
      const resData = await response.json();
      if (resData.status && resData.dataItems && resData.dataItems.length > 0) {
        setModalClaimData(resData.dataItems[0]);
      }
    } catch (err) {
      console.error("Error fetching claim details for modal preview:", err);
    }
  };
  useEffect(() => {
    const storedInvoices = localStorage.getItem("invoices");
    if (storedInvoices) {
      setInvoices(JSON.parse(storedInvoices));
    }
  }, []);

  const formatcreateDate = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);

    if (date.toString() === "Invalid Date" && dateStr.includes("-")) {
      const [day, month, year] = dateStr.split(" ")[0].split("-");
      return `${day}-${month}-${year}`;
    }

    return date.toLocaleDateString("en-GB");
  };
  const downloadCSV = () => {
    const headers = [
      "AANumber",
      "IMEINumber",
      "CustomerName",
      // "ServiceType",
      "Brand",
      "MakeModel",
      "RepairCharges",
      "ServiceCharges (Pre GST)",
      "Total",
      "InvoiceStatus",
      // "Remarks",
      // "RemarkFile",
      // "Remarks",
      // "Remark File",
    ];

    const today = new Date().toLocaleDateString("en-GB");

    const data = selectedAAno.map((invoice) => ({

      aaNumber: invoice.aA_Number || "",
      imeiNumber: invoice.imeiNumber || "",
      customerName: invoice.customerName || "",
      // serviceType: invoice.serviceType || "",
      brand: invoice.brand || "",
      makeModel: invoice.makeModel || "",
      repairCharges: invoice.repairCharges || "0.00",
      serviceCharges: invoice.serviceCharges || "0.00",
      total: invoice.total || "0.00",
      invoiceStatus: invoice.networkAndFinanceStatus || "",
      // remarks: invoice.remarks || "",
      // remarkFile: invoice.remarkFile
      //   ? invoice.remarkFile.name || invoice.remarkFile
      //   : "",

    }));

    const csv = Papa.unparse({
      fields: headers,
      data: data.map(row => Object.values(row)),
    }, {
      quotes: true,
      quoteChar: '"',
      delimiter: ',',
      newline: '\r\n'
    });

    const vendorName =
      selectedAAno?.[0]?.sellingPartner?.replace(/\s+/g, "_") || "invoice";

    const fileName = `${vendorName}_list.csv`;

    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, fileName);
  };

  const handleDownloadInvoice = () => {
    const invoiceUrl = batchData?.invoice;
    if (!invoiceUrl) {
      toast.error("No invoice URL available for download.");
      return;
    }
    const fileName = invoiceUrl.split("/").pop() || "invoice.pdf";
    const link = document.createElement("a");
    link.href = invoiceUrl;
    link.download = fileName;
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // const handleSaveRemark = async () => {
  //   try {
  //     const selected = invoices.filter((inv) => inv.isChecked);
  //     const aaNumbers = selected.map((inv) => inv.aA_Number).join(",");
  // 
  //     if (!aaNumbers) {
  //       console.warn("No AA Numbers found for remark update");
  //       return true;
  //     }
  // 
  //     const actionLogsMap = {
  //       "Approved": "Approved",
  //       "Saved": "Saved",
  //       "Partially Approved": "Partially Approved",
  //       "Send Back": "Send Back",
  //       "Rejected by Network": "Rejected by Network"
  //     };
  //     // Include AA numbers in the logs
  //     // const logsValue = `${aaNumbers} ${actionLogsMap[modalActionType] || modalActionType || "Updated"}`;
  //     const logsValue = actionLogsMap[modalActionType] || modalActionType || "Updated";
  // 
  //     const formData = new FormData();
  //     formData.append("aA_Number", aaNumbers);
  //     formData.append("remarks", batchRemark || "");
  //     formData.append("remarkAndLogBy", user.role);
  //     formData.append("batchNo", batchData?.batchNo);
  //     formData.append("logs", logsValue);
  // 
  //     const res = await fetch(`${BASE_URL}/InsertLogsAndRemarksTracking`, {
  //       method: "POST",
  //       body: formData,
  //     });
  // 
  //     const data = await res.json();
  // 
  //     if (!res.ok || !data.status) {
  //       toast.error(data.message || "Failed to update remark.");
  //       return;
  //     }
  // 
  //     toast.success("Remark saved successfully.");
  // 
  //     // Call the nextAction if provided
  //     if (typeof nextAction === "function") {
  //       await nextAction();
  //     }
  // 
  //     // Reset modal
  //     setShowRemarkModal(false);
  //     setBatchRemark("");
  //   } catch (err) {
  //     console.error("Remark update failed:", err);
  //     toast.error("Failed to update remark.");
  //   }
  // };

  const getAllowedAANumbers = () => {
    const aaNumbers = currentInvoices
      .map(invoice => invoice.uniquePending)
      .filter(Boolean); // removes null/undefined/empty strings

    // If ALL uniquePending values are blank/null → return null (special case)
    if (aaNumbers.length === 0) return null;

    return aaNumbers.flatMap(aaString =>
      aaString.split(",").map(aa => aa.trim())
    );
  };

  const isRowDisabled = (invoice) => {
    const allowedAA = getAllowedAANumbers();

    // If no AA numbers → all rows active
    if (allowedAA === null) return false;

    // Otherwise → only allow rows in the allowed list
    return !allowedAA.includes(invoice.aA_Number);
  };
  const getDisabledAANumbers = () => {
    return invoices
      .filter(inv => isRowDisabled(inv)) // only disabled rows
      .map(inv => inv.aA_Number || "")
      .filter(Boolean)
      .join(",");
  };

  const selectedInvoices = invoices.filter((invoice) => invoice.isChecked && !isRowDisabled(invoice));

  const leftSideTotalRepairCharges = selectedInvoices.reduce((total, invoice) => {
    const cleanedAmount = invoice.repairCharges?.toString().replace(/,/g, "");
    const amount = parseFloat(cleanedAmount);
    return total + (isNaN(amount) ? 0 : amount);
  }, 0);

  const leftSideTotalServiceCharges = selectedInvoices.reduce((total, invoice) => {
    const cleanedAmount = invoice.serviceCharges?.toString().replace(/,/g, "");
    const amount = parseFloat(cleanedAmount);
    return total + (isNaN(amount) ? 0 : amount);
  }, 0);

  const leftSideGstAmount = isGSTApplied
    ? (leftSideTotalServiceCharges * 0.18).toFixed(2)
    : (0).toFixed(2);

  const leftSideGrossAmount = leftSideTotalRepairCharges + leftSideTotalServiceCharges;
  const leftSideFinalAmount = isGSTApplied
    ? (leftSideGrossAmount + parseFloat(leftSideGstAmount)).toFixed(2)
    : leftSideGrossAmount.toFixed(2);

  const leftSideTotalservicechargewithGST = (leftSideTotalServiceCharges + parseFloat(leftSideGstAmount)).toFixed(2);
  const leftSideCaseCount = selectedInvoices.length;

  const handleSubmit = async () => {

    const activeInvoices = invoices.filter((inv) => !isRowDisabled(inv));

    const selectedInvoices = activeInvoices.filter((inv) => inv.isChecked);
    const unselectedInvoices = activeInvoices.filter((inv) => !inv.isChecked);

    const selectedapproveinvoice = invoices.filter((inv) => inv.isChecked);

    if (selectedInvoices.length === 0 && unselectedInvoices.length === 0) {
      toast.error("Please select at least one invoice.");
      return;
    }

    if (selectedInvoices.length > 0) {
      const yellowRowsWithoutRemarks = selectedInvoices.filter(
        (invoice) =>
          getRowClassName(invoice) === "row-yellow" && !invoice.remarks?.trim()
      )
      if (yellowRowsWithoutRemarks.length > 0) {
        const aaNumbers = yellowRowsWithoutRemarks
          .map((inv) => inv.aA_Number)
          .join(", ");
        toast.error(
          `Cannot approve invoices with mismatched data without remarks. Please add remarks for AA Numbers: ${aaNumbers}.`
        );
        return;
      }
    }

    if (selectedInvoices.length > 0) {

      const extract = (key) =>
        invoices.map((item) => item[key] || "").join(", ");
      const formData = new FormData();
      formData.append("sellingPartner", extract("sellingPartner") || "");
      formData.append("aaNo", extract("aA_Number") || "");
      formData.append("imeiNo", extract("imeiNumber") || "");
      // formData.append("creationDate", extract("creationDate")); 
      // formData.append("closureDate", extract("closureDate"));
      formData.append("creationDate", new Date().toISOString());
      formData.append("closureDate", new Date().toISOString());
      formData.append("customerName", extract("customerName") || "");
      formData.append("serviceType", extract("serviceType") || "");
      formData.append("brand", extract("brand") || "");
      formData.append("makeModel", extract("makeModel") || "");
      formData.append("repairCharges", extract("repairCharges") || "0.00");
      formData.append("serviceCharges", extract("serviceCharges") || "0.00");

      // formData.append("invoiceStatus", "Approve");
      formData.append("total", extract("total") || "0.00");
      const allSelected = unselectedInvoices.length === 0;
      formData.append("invoiceStatus", allSelected ? "Processed" : "");

      formData.append("batchNo", batchData?.batchNo || "");
      formData.append("selectedService", "");
      formData.append(
        "totalRepairCharges",
        parseFloat(leftSideTotalRepairCharges).toFixed(2)
      );
      formData.append("totalServiceCharges", leftSideTotalservicechargewithGST);
      formData.append("finalAmount", parseFloat(leftSideFinalAmount).toFixed(2));
      formData.append("gst", leftSideGstAmount);
      formData.append("invoiceNo", invoiceNo || "");
      formData.append("invoiceDate", invoiceDate || "");
      formData.append("invoiceAmount", invoiceAmount || "0.00");
      if (uploadedFile instanceof File) {
        formData.append("invoice", uploadedFile, uploadedFile.name);
      } else if (existingInvoice?.url) {
        const fileUrl = existingInvoice.url;
        const fileName = fileUrl.split("fileName=")[1] || fileUrl.split("/").pop();
        formData.append("invoice", fileName);
      } else {
        formData.append("invoice", "");
      }
      formData.append("vendorName", batchData?.vendorName || "");
      // formData.append("caseCount", selectedInvoices.length.toString());
      formData.append("caseCount", batchData.caseCount);

      formData.append("remarks", extract("remarks") || "");
      formData.append("remarkFile", extract("remarkFile") || "");
      formData.append(
        "UniqueApproval",
        selectedInvoices.map((inv) => inv.aA_Number).join(",") || ""
      );
      formData.append(
        "UniquePartial",
        unselectedInvoices.map((inv) => inv.aA_Number).join(",") || ""
      );
      const previousStatusMap = invoices.reduce((acc, inv) => {
        if (inv.aA_Number && inv.networkAndFinanceStatus) {
          acc[inv.aA_Number] = inv.networkAndFinanceStatus;
        }
        return acc;
      }, {});

      const networkAndFinanceStatus = invoices
        .map((inv) => {
          const isSelected = selectedapproveinvoice.some(
            (sel) => sel.aA_Number === inv.aA_Number
          );

          if (isSelected) {
            if (isRowDisabled(inv)) {
              console.log(
                `Row ${inv.aA_Number} is selected but DISABLED → keeping previous status:`,
                previousStatusMap[inv.aA_Number]
              );
              return previousStatusMap[inv.aA_Number] || "Partially Approved";
            } else {
              // console.log(`Row ${inv.aA_Number} is selected and active → Invoice Approved`);
              return "Invoice Approved";
            }
          } else {
            return "Approval Pending";
          }
        })
        .join(",");

      formData.append("NetworkAndFinanceStatus", networkAndFinanceStatus);

      if (!formData.get("aaNo")) {
        toast.error("AA Numbers are required for partial approval.");
        return;
      }
      if (!formData.get("batchNo")) {
        toast.error("Batch Number is required for partial approval.");
        return;
      }


      try {
        setLoading(true);
        console.log("Sending FormData for Partial Approval:");
        for (let [key, value] of formData.entries()) {
          console.log(`${key}: ${value}`);
        }

        const response = await fetch(`${BASE_URL}/approvefromnetwork`, {
          method: "POST",
          body: formData,
        });

        const result = await response.json();
        if (!response.ok) {
          console.error("API error for approval:", {
            status: response.status,
            statusText: response.statusText,
            responseBody: result,
          });
          toast.error(
            `Error in approval: ${result.message || "Unknown error"} (Status: ${response.status
            })`
          );
          return;
        }
        const aanoString = selectedInvoices.map((item) => item.aA_Number).join(",");

        const remarkFormData = new FormData();
        remarkFormData.append("AANo", aanoString);
        remarkFormData.append("Remark", "Batch Approved");
        remarkFormData.append("BatchNo", batchData.batchNo);
        remarkFormData.append("ByWhom", user?.role);


        try {
          const res = await fetch(`${BASE_URL}/UpdateRemarkAgainstBatch`, {
            method: "POST",
            body: remarkFormData,
          });
        } catch (remarkError) {
          console.error("Failed to update remarks:", remarkError);
        }
        await Swal.fire({
          icon: "success",
          title: `BatchNo:${batchData?.batchNo}`,
          text: "✅Your batch has been approved successfully.",
          confirmButtonColor: "#7E00D1",
          confirmButtonText: "OK",
        });

        localStorage.removeItem("invoices");

        setTimeout(async () => {
          try {
            const linkPayload = selectedInvoices.map((item) => ({
              aA_Number: item.aA_Number,
              // invoiceStatus: uploadedFile || batchData?.invoice ? "Invoice Uploaded" : item.invoiceStatus,
              invoiceStatus: "Processed",
              batchNo: batchData?.batchNo || "",
              invoiceNumber: invoiceNo,
              invoiceDate: new Date(invoiceDate).toISOString(),
              invoiceAmount: parseFloat(invoiceAmount),
              invoice: batchData?.invoice ? batchData?.invoice : uploadedFile.name,
              financeStatus: "N/A",
            }));

            for (const payload of linkPayload) {
              await fetch(`${BASE_URL}/LinkOperationsToGadget`, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
              });
            }

          } catch (error) {
            console.error("Error calling LinkOperationsToGadget API:", error);
          }
        }, 2000);

        navigate("/approval");

      } catch (error) {
        console.error(" approval failed:", {
          message: error.message,
          stack: error.stack,
          formData: Object.fromEntries(formData.entries()),
        });
        toast.error(
          `Partial approval failed: ${error.message}. Check console for details.`
        );
        return;
      }
    }
  };

  const handleSaveData = async () => {
    const allInvoices = invoices; // ✅ include all rows
    if (!allInvoices || allInvoices.length === 0) {
      toast.error("No invoices available to save.");
      return;
    }

    // Validate yellow rows for remarks in all invoices (since we're saving all)
    const yellowRowsWithoutRemarks = allInvoices.filter(
      (invoice) =>
        getRowClassName(invoice) === "row-yellow" && !invoice.remarks?.trim()
    );

    if (yellowRowsWithoutRemarks.length > 0) {
      const aaNumbers = yellowRowsWithoutRemarks
        .map((inv) => inv.aA_Number)
        .join(", ");
      toast.error(
        `Cannot approve invoices with mismatched data without remarks. Please add remarks for AA Numbers: ${aaNumbers}.`
      );
      return;
    }

    // ✅ Swal message for confirmation
    Swal.fire({
      title: `BatchNo: ${batchData?.batchNo}`,
      text: "✅ Batch Saved",
      icon: "success",
      confirmButtonColor: "#7E00D1",
      confirmButtonText: "OK",
    });

    // ✅ Prepare form data
    const extract = (key) => allInvoices.map((item) => item[key] || "").join(", ");
    const formData = new FormData();

    formData.append("sellingPartner", extract("sellingPartner") || "");
    formData.append("aaNo", extract("aA_Number") || "");
    formData.append("imeiNo", extract("imeiNumber") || "");
    formData.append("creationDate", new Date().toISOString());
    formData.append("closureDate", new Date().toISOString());
    formData.append("customerName", extract("customerName") || "");
    formData.append("serviceType", extract("serviceType") || "");
    formData.append("brand", extract("brand") || "");
    formData.append("makeModel", extract("makeModel") || "");
    formData.append("repairCharges", extract("repairCharges") || "0.00");
    formData.append("serviceCharges", extract("serviceCharges") || "0.00");
    formData.append("total", extract("total") || "0.00");
    formData.append("invoiceStatus", "Invoice Uploaded");
    formData.append("batchNo", batchData?.batchNo || "");
    formData.append("selectedService", "");
    formData.append(
      "totalRepairCharges",
      parseFloat(leftSideTotalRepairCharges).toFixed(2)
    );
    formData.append("totalServiceCharges", leftSideTotalservicechargewithGST);
    formData.append("finalAmount", parseFloat(leftSideFinalAmount).toFixed(2));
    formData.append("gst", leftSideGstAmount);
    formData.append("invoiceNo", invoiceNo || "");
    formData.append("invoiceDate", invoiceDate || "");
    formData.append("invoiceAmount", invoiceAmount || "0.00");

    // ✅ Handle file upload or existing file
    if (uploadedFile instanceof File) {
      formData.append("invoice", uploadedFile, uploadedFile.name);
    } else if (existingInvoice?.url) {
      const fileUrl = existingInvoice.url;
      const fileName = fileUrl.split("fileName=")[1] || fileUrl.split("/").pop();
      formData.append("invoice", fileName);
    } else {
      formData.append("invoice", "");
    }

    formData.append("vendorName", batchData?.vendorName || "");
    formData.append("caseCount", caseCount);
    formData.append("remarks", extract("remarks") || "");
    formData.append("remarkFile", extract("remarkFile") || "");

    // ✅ Basic validations
    if (!formData.get("aaNo")) {
      toast.error("AA Numbers are required.");
      return;
    }
    if (!formData.get("batchNo")) {
      toast.error("Batch Number is required.");
      return;
    }

    try {
      setLoading(true);
      console.log("Sending FormData for saving all invoices:");
      for (let [key, value] of formData.entries()) {
        console.log(`${key}: ${value}`);
      }

      const response = await fetch(`${BASE_URL}/UpdatePendingData`, {
        method: "POST",
        body: formData,
      });

      const result = await response.json();
      if (!response.ok) {
        console.error("API error:", {
          status: response.status,
          statusText: response.statusText,
          responseBody: result,
        });
        toast.error(
          `Error in saving batch: ${result.message || "Unknown error"} (Status: ${response.status})`
        );
        return;
      }

      // ✅ Save remark for the whole batch
      const aanoString = allInvoices.map((item) => item.aA_Number).join(",");
      const remarkFormData = new FormData();
      remarkFormData.append("AANo", aanoString);
      remarkFormData.append("Remark", "Batch Submitted for Approval");
      remarkFormData.append("BatchNo", batchData.batchNo);
      remarkFormData.append("ByWhom", user?.role);

      try {
        await fetch(`${BASE_URL}/UpdateRemarkAgainstBatch`, {
          method: "POST",
          body: remarkFormData,
        });
      } catch (remarkError) {
        console.error("Failed to update remarks:", remarkError);
      }

      localStorage.removeItem("invoices");
      navigate("/approval");
    } catch (error) {
      console.error("Batch save failed:", {
        message: error.message,
        stack: error.stack,
        formData: Object.fromEntries(formData.entries()),
      });
      toast.error(`Batch save failed: ${error.message}. Check console for details.`);
    } finally {
      setLoading(false);
    }
  };

  // const handleSubmitWithRemark = () => {
  //   setModalActionType("Approved");
  //   setShowRemarkModal(true);
  //   setNextAction(() => handleSubmit);
  // };
  // 
  // const handleSaveDataWithRemark = () => {
  //   setModalActionType("Saved");
  //   setShowRemarkModal(true);
  //   setNextAction(() => handleSaveData);
  // };
  // const handlePartialWithRemark = () => {
  //   setModalActionType("Partially Approved");
  //   setShowRemarkModal(true);
  //   setNextAction(() => handleSendPartialAction);
  // };
  // const handleBackWithRemark = () => {
  //   setModalActionType("Send Back");
  //   setShowRemarkModal(true);
  //   setNextAction(() => handleSendBackAction);
  // };
  // const handleRejectWithRemark = () => {
  //   setModalActionType("Rejected by Network");
  //   setShowRemarkModal(true);
  //   setNextAction(() => handleNetworkReject);
  // };
  /*
  const handleSendPartialAction = async () => {
    const selectedInvoices = invoices.filter((inv) => inv.isChecked);
    const unselectedInvoices = invoices.filter((inv) => !inv.isChecked);

    if (selectedInvoices.length === 0) {
      toast.error("Please select at least one invoice for partial approval.");
      return;
    }

    //-----------check remarks for yellow rows
    const yellowRowsWithoutRemarks = selectedInvoices.filter(
      (invoice) =>
        getRowClassName(invoice) === "row-yellow" && !invoice.remarks?.trim()
    );
    if (yellowRowsWithoutRemarks.length > 0) {
      const aaNumbers = yellowRowsWithoutRemarks
        .map((inv) => inv.aA_Number)
        .join(", ");
      toast.error(
        `Cannot partially approve invoices without remarks for: ${aaNumbers}`
      );
      return;
    }

    Swal.fire({
      title: `BatchNo:${batchData?.batchNo}`,
      text: "✅ Batch Submitted for Partial Approval",
      icon: "success",
      confirmButtonColor: "#7E00D1",
      confirmButtonText: "OK",
    });

    const extract = (key) =>
      invoices.map((item) => item[key] || "").join(", ");

    //-------check if all selected
    const allSelected = unselectedInvoices.length === 0;

    //--------extract only fileName
    let fileName = "";
    if (uploadedFile) {
      fileName = uploadedFile.name;
    } else if (existingInvoice?.url) {
      fileName = existingInvoice.url.split("fileName=")[1] || "";
    }
    const selectedAA = selectedInvoices
      .filter(item => !isRowDisabled(item))
      .map(item => item.aA_Number || "")
      .filter(Boolean)
      .join(",");
    console.log(selectedAA, 'selected AA')
    // ----------unselected AA numbers
    const unselectedAA = unselectedInvoices
      .map((item) => item.aA_Number || "")
      .filter(Boolean)
      .join(",");

    // ----------disabled AA numbers
    const disabledAA = getDisabledAANumbers();
    const previousStatusMap = invoices.reduce((acc, inv) => {
      if (inv.aA_Number && inv.networkAndFinanceStatus) {
        acc[inv.aA_Number] = inv.networkAndFinanceStatus;
      }
      return acc;
    }, {});

    const effectiveSelectedInvoices = selectedInvoices.filter(
      inv => !isRowDisabled(inv)
    );

    const allAA = invoices.map(inv => inv.aA_Number).filter(Boolean);

    const statusList = allAA.map(invAA => {
      if (effectiveSelectedInvoices.some(inv => inv.aA_Number === invAA)) {
        return "Partially Approved";
      }

      if (isRowDisabled({ aA_Number: invAA })) {
        return previousStatusMap[invAA] || "Approval Pending";
      }

      return "Approval Pending";
    });

    const networkAndFinanceStatus = statusList.join(",");

    const payload = {
      sellingPartner: extract("sellingPartner"),
      aaNo: extract("aA_Number"),
      imeiNo: extract("imeiNumber"),
      creationDate: new Date().toISOString(),
      closureDate: new Date().toISOString(),
      customerName: extract("customerName"),
      serviceType: extract("serviceType"),
      brand: extract("brand"),
      makeModel: extract("makeModel"),
      repairCharges: extract("repairCharges") || "0.00",
      total: extract("total") || "0.00",
      invoiceStatus: allSelected ? "Partial" : "",
      batchNo: batchData?.batchNo || "",
      selectedService: "",
      totalRepairCharges: parseFloat(leftSideTotalRepairCharges).toFixed(2),
      serviceCharges: extract("serviceCharges") || "0.00",
      finalAmount: parseFloat(leftSideFinalAmount).toFixed(2),
      gst: leftSideGstAmount,
      invoiceNo: invoiceNo || "",
      // invoiceDate: invoiceDate || new Date().toISOString(),
      invoiceDate: invoiceDate
        ? parseInvoiceDate(invoiceDate).toISOString()
        : new Date().toISOString(),

      invoiceAmount: invoiceAmount || "0.00",
      invoice: fileName || "",
      vendorName: batchData?.vendorName || "",
      // caseCount: invoices.length.toString(),
      // caseCount: selectedAAno.length.toString(),
      caseCount: batchData.caseCount,
      totalServiceCharges: leftSideTotalservicechargewithGST,
      remarks: extract("remarks"),
      remarkFile: extract("remarkFile"),
      uniquePartial: selectedAA,
      uniquePending: unselectedAA,
      type: "Partial",
      NetworkAndFinanceStatus: networkAndFinanceStatus
    };

    console.log(payload, 'payloadddd')
    try {
      setLoading(true);
      const response = await fetch(`${BASE_URL}/PendingToPartial`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      if (!response.ok) {
        toast.error(
          `Partial approval failed: ${result.message || "Unknown error"}`
        );
        return;
      }
      const aanoString = selectedInvoices.map((item) => item.aA_Number).join(",");

      const remarkFormData = new FormData();
      remarkFormData.append("AANo", aanoString);
      remarkFormData.append("Remark", "Batch Submitted for Partial Approval");
      remarkFormData.append("BatchNo", batchData.batchNo);
      remarkFormData.append("ByWhom", user?.role);

      try {
        const res = await fetch(`${BASE_URL}/UpdateRemarkAgainstBatch`, {
          method: "POST",
          body: remarkFormData,
        });
      } catch (remarkError) {
        console.error("Failed to update remarks:", remarkError);
      }
      // await Swal.fire({
      //   icon: "success",
      //   title: "Batch Partially Approved",
      //   text: "Partial approval submitted successfully.",
      //   confirmButtonColor: "#3085d6"
      // });

      localStorage.removeItem("invoices");
      navigate("/partialApproval", {
        state: { updatedInvoices: selectedInvoices },
      });
    } catch (error) {
      console.error("Partial approval error:", error);
      toast.error("Partial approval failed. Check console.");
    } finally {
      setLoading(false);
    }
  };
  function parseInvoiceDate(dateStr) {
    if (!dateStr) return new Date();

    const parsed = Date.parse(dateStr);

    if (!isNaN(parsed)) {
      return new Date(parsed);
    }

    const cleaned = dateStr.replace("AM", " AM").replace("PM", " PM");
    const dateObj = new Date(cleaned);

    if (!isNaN(dateObj.getTime())) {
      return dateObj;
    }

    throw new Error("Invalid date format: " + dateStr);
  }

  const handleSendBackAction = async () => {
    const selectedBackInvoices = invoices.filter((inv) => inv.isChecked);
    const unselectedBackInvoices = invoices.filter((inv) => !inv.isChecked);

    if (selectedBackInvoices.length === 0) {
      toast.error("Please select at least one invoice to send back.");
      return;
    }

    Swal.fire({
      title: `BatchNo:${batchData?.batchNo}`,
      text: "✅ Batch Send Back",
      icon: "success",
      confirmButtonColor: "#7E00D1",
      confirmButtonText: "OK",
    });
    const extract = (key) =>
      invoices.map((item) => item[key] || "").join(", ");

    // -----------------if all rows selected → Back
    const allSelected = unselectedBackInvoices.length === 0;

    let fileName = "";
    if (uploadedFile) {
      fileName = uploadedFile.name;
    } else if (existingInvoice?.url) {
      fileName = existingInvoice.url.split("fileName=")[1] || "";
    }

    // -----------new logic ----------------
    const selectedAA = selectedBackInvoices
      .filter(item => !isRowDisabled(item))
      .map(item => item.aA_Number || "")
      .filter(Boolean)
      .join(",");
    // --------------------unselected AA numbers (pending)
    const unselectedAA = unselectedBackInvoices
      .map((item) => item.aA_Number || "")
      .filter(Boolean)
      .join(",");

    // ----------disabled AA numbers
    const disabledAA = getDisabledAANumbers();

    const previousStatusMap = invoices.reduce((acc, inv) => {
      if (inv.aA_Number && inv.networkAndFinanceStatus) {
        acc[inv.aA_Number] = inv.networkAndFinanceStatus;
      }
      return acc;
    }, {});

    const effectiveSelectedInvoices = selectedBackInvoices.filter(
      inv => !isRowDisabled(inv)
    );

    const allAA = invoices.map(inv => inv.aA_Number).filter(Boolean);

    const statusList = allAA.map(invAA => {
      if (effectiveSelectedInvoices.some(inv => inv.aA_Number === invAA)) {
        return "Send To Back";
      }

      if (isRowDisabled({ aA_Number: invAA })) {
        return previousStatusMap[invAA] || "Approval Pending";
      }

      return "Approval Pending";
    });

    const networkAndFinanceStatus = statusList.join(",");

    const payload = {
      sellingPartner: extract("sellingPartner"),
      aaNo: extract("aA_Number"),
      imeiNo: extract("imeiNumber"),
      creationDate: new Date().toISOString(),
      closureDate: new Date().toISOString(),
      customerName: extract("customerName"),
      serviceType: extract("serviceType"),
      brand: extract("brand"),
      makeModel: extract("makeModel"),
      repairCharges: extract("repairCharges") || "0.00",
      total: extract("total") || "0.00",
      invoiceStatus: allSelected ? "Back" : "",
      batchNo: batchData?.batchNo || "",
      selectedService: "",
      totalRepairCharges: parseFloat(leftSideTotalRepairCharges).toFixed(2),
      serviceCharges: extract("serviceCharges") || "0.00",
      finalAmount: parseFloat(leftSideFinalAmount).toFixed(2),
      gst: isGSTApplied ? parseFloat(leftSideGstAmount).toFixed(2) : "0.00",
      invoiceNo: invoiceNo || "",
      // invoiceDate: invoiceDate || new Date().toISOString(),
      invoiceDate: invoiceDate
        ? parseInvoiceDate(invoiceDate).toISOString()
        : new Date().toISOString(),

      invoiceAmount: invoiceAmount || "0.00",
      invoice: fileName || "",
      vendorName: batchData?.vendorName || "",
      // caseCount: invoices.length.toString(),
      // caseCount: selectedAAno.length.toString(),
      caseCount: batchData.caseCount,
      totalServiceCharges: parseFloat(leftSideTotalservicechargewithGST).toFixed(2),
      remarks: extract("remarks"),
      remarkFile: extract("remarkFile"),
      uniqueAABackPartial: selectedAA,
      uniquePending: unselectedAA,
      NetworkAndFinanceStatus: networkAndFinanceStatus,
      type: "Back"
    };

    console.log(payload, 'back payload')
    try {
      setLoading(true);
      const response = await fetch(`${BASE_URL}/PendingToBack`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      if (!response.ok) {
        toast.error(`Send back failed: ${result.message || "Unknown error"}`);
        return;
      }
      const aanoString = selectedBackInvoices.map((item) => item.aA_Number).join(",");

      const remarkFormData = new FormData();
      remarkFormData.append("AANo", aanoString);
      remarkFormData.append("Remark", "Batch Send to Back");
      remarkFormData.append("BatchNo", batchData.batchNo);
      remarkFormData.append("ByWhom", user?.role);
      try {
        const res = await fetch(`${BASE_URL}/UpdateRemarkAgainstBatch`, {
          method: "POST",
          body: remarkFormData,
        });
      } catch (remarkError) {
        console.error("Failed to update remarks:", remarkError);
      }
      localStorage.removeItem("invoices");
      navigate("/sendBackByapproval", {
        state: { sentBackInvoices: selectedBackInvoices },
      });
    } catch (error) {
      console.error("Send back error:", error);
      toast.error("Send back failed. Check console.");
    } finally {
      setLoading(false);
    }
  };

  const handleNetworkReject = async () => {
    const selectedInvoices = invoices.filter((inv) => inv.isChecked);
    const unselectedInvoices = invoices.filter((inv) => !inv.isChecked);

    if (selectedInvoices.length === 0 && unselectedInvoices.length === 0) {
      toast.error("Please select at least one invoice.");
      return;
    }

    if (selectedInvoices.length > 0) {
      const yellowRowsWithoutRemarks = selectedInvoices.filter(
        (invoice) =>
          getRowClassName(invoice) === "row-yellow" && !invoice.remarks?.trim()
      );
      if (yellowRowsWithoutRemarks.length > 0) {
        const aaNumbers = yellowRowsWithoutRemarks
          .map((inv) => inv.aA_Number)
          .join(", ");
        toast.error(
          `Cannot approve invoices with mismatched data without remarks. Please add remarks for AA Numbers: ${aaNumbers}.`
        );
        return;
      }
    }

    if (selectedInvoices.length > 0) {
      const extract = (key) =>
        invoices.map((item) => item[key] || "").join(", ");

      const selectedAA = selectedInvoices
        .filter(item => !isRowDisabled(item))
        .map(item => item.aA_Number || "")
        .filter(Boolean)
        .join(",");

      // --------------------unselected AA numbers (pending)
      const unselectedAA = unselectedInvoices
        .map((item) => item.aA_Number || "")
        .filter(Boolean)
        .join(",");
      // ----------disabled AA numbers
      const disabledAA = getDisabledAANumbers();

      const previousStatusMap = invoices.reduce((acc, inv) => {
        if (inv.aA_Number && inv.networkAndFinanceStatus) {
          acc[inv.aA_Number] = inv.networkAndFinanceStatus;
        }
        return acc;
      }, {});

      const effectiveSelectedInvoices = selectedInvoices.filter(
        inv => !isRowDisabled(inv)
      );

      const allAA = invoices.map(inv => inv.aA_Number).filter(Boolean);

      const statusList = allAA.map(invAA => {
        if (effectiveSelectedInvoices.some(inv => inv.aA_Number === invAA)) {
          return "Invoice Rejected ";
        }

        if (isRowDisabled({ aA_Number: invAA })) {
          return previousStatusMap[invAA] || "Approval Pending";
        }

        return "Approval Pending";
      });

      const networkAndFinanceStatus = statusList.join(",");

      const payload = {
        sellingPartner: extract("sellingPartner"),
        aaNo: extract("aA_Number"),
        imeiNo: extract("imeiNumber"),
        creationDate: new Date().toISOString(),
        closureDate: new Date().toISOString(),
        customerName: extract("customerName"),
        serviceType: extract("serviceType"),
        brand: extract("brand"),
        makeModel: extract("makeModel"),
        repairCharges: extract("repairCharges") || "0.00",
        total: extract("total") || "0.00",
        invoiceStatus: unselectedInvoices.length === 0 ? "Rejected" : "",
        batchNo: batchData?.batchNo || "",
        selectedService: "", // can fill if needed
        finalAmount: parseFloat(finalAmount).toFixed(2),
        gst: gstAmount,
        invoiceNo: invoiceNo || "",
        invoiceDate: invoiceDate || "",
        invoiceAmount: invoiceAmount || "0.00",
        invoice: existingInvoice?.url || "",
        vendorName: batchData?.vendorName || "",
        caseCount: batchData?.caseCount,
        totalRepairCharges: parseFloat(totalRepairCharges).toFixed(2),
        totalServiceCharges: totalservicechargewithGST,
        remarks: extract("remarks"),
        remarkFile: extract("remarkFile"),
        serviceCharges: extract("serviceCharges") || "0.00",
        uniqueRejected: selectedAA,
        uniquePending: unselectedAA,
        NetworkAndFinanceStatus: networkAndFinanceStatus,
      };

      console.log(payload, 'payloooo')
      // Required field validations
      if (!payload.aaNo) {
        toast.error("AA Numbers are required for partial approval.");
        return;
      }
      if (!payload.batchNo) {
        toast.error("Batch Number is required for partial approval.");
        return;
      }


      try {
        setLoading(true);
        console.log("Sending JSON for Partial Approval:", payload);

        const response = await fetch(
          `${BASE_URL}/Insert_NetworkRejectedBatches`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify(payload)
          }
        );

        const result = await response.json();
        if (!response.ok) {
          console.error("API error for approval:", {
            status: response.status,
            statusText: response.statusText,
            responseBody: result
          });
          toast.error(
            `Error in approval: ${result.message || "Unknown error"
            } (Status: ${response.status})`
          );
          return;
        }
        const aanoString = selectedInvoices.map((item) => item.aA_Number).join(",");

        const remarkFormData = new FormData();
        remarkFormData.append("AANo", aanoString);
        remarkFormData.append("Remark", `${aanoString} Rejected by Network`);
        remarkFormData.append("BatchNo", batchData.batchNo);
        remarkFormData.append("ByWhom", user?.role);

        try {
          const res = await fetch(`${BASE_URL}/UpdateRemarkAgainstBatch`, {
            method: "POST",
            body: remarkFormData,
          });
        } catch (remarkError) {
          console.error("Failed to update remarks:", remarkError);
        }

        localStorage.removeItem("invoices");
        navigate("/networkRejectedCases");
      } catch (error) {
        console.error("Approval failed:", {
          message: error.message,
          stack: error.stack,
          payload
        });
        toast.error(
          `Partial approval failed: ${error.message}. Check console for details.`
        );
      } finally {
        setLoading(false);
      }
    }
  };
  */


  const handleNetworkReject = async () => {
    const selectedInvoices = invoices.filter((inv) => inv.isChecked);
    const unselectedInvoices = invoices.filter((inv) => !inv.isChecked);

    if (selectedInvoices.length === 0 && unselectedInvoices.length === 0) {
      toast.error("Please select at least one invoice.");
      return;
    }

    if (selectedInvoices.length > 0) {
      const yellowRowsWithoutRemarks = selectedInvoices.filter(
        (invoice) =>
          getRowClassName(invoice) === "row-yellow" && !invoice.remarks?.trim()
      );
      if (yellowRowsWithoutRemarks.length > 0) {
        const aaNumbers = yellowRowsWithoutRemarks
          .map((inv) => inv.aA_Number)
          .join(", ");
        toast.error(
          `Cannot approve invoices with mismatched data without remarks. Please add remarks for AA Numbers: ${aaNumbers}.`
        );
        return;
      }
    }

    if (selectedInvoices.length > 0) {
      const extract = (key) =>
        invoices.map((item) => item[key] || "").join(", ");

      const selectedAA = selectedInvoices
        .filter(item => !isRowDisabled(item))
        .map(item => item.aA_Number || "")
        .filter(Boolean)
        .join(",");

      // --------------------unselected AA numbers (pending)
      const unselectedAA = unselectedInvoices
        .map((item) => item.aA_Number || "")
        .filter(Boolean)
        .join(",");
      // ----------disabled AA numbers
      const disabledAA = getDisabledAANumbers();

      const previousStatusMap = invoices.reduce((acc, inv) => {
        if (inv.aA_Number && inv.networkAndFinanceStatus) {
          acc[inv.aA_Number] = inv.networkAndFinanceStatus;
        }
        return acc;
      }, {});

      const effectiveSelectedInvoices = selectedInvoices.filter(
        inv => !isRowDisabled(inv)
      );

      const allAA = invoices.map(inv => inv.aA_Number).filter(Boolean);

      const statusList = allAA.map(invAA => {
        if (effectiveSelectedInvoices.some(inv => inv.aA_Number === invAA)) {
          return "Ready For Billing ";
        }

        if (isRowDisabled({ aA_Number: invAA })) {
          return previousStatusMap[invAA] || "Approval Pending";
        }

        return "Approval Pending";
      });

      const networkAndFinanceStatus = statusList.join(",");

      const payload = {
        sellingPartner: extract("sellingPartner"),
        aaNo: extract("aA_Number"),
        imeiNo: extract("imeiNumber"),
        creationDate: new Date().toISOString(),
        closureDate: new Date().toISOString(),
        customerName: extract("customerName"),
        serviceType: extract("serviceType"),
        brand: extract("brand"),
        makeModel: extract("makeModel"),
        repairCharges: extract("repairCharges") || "0.00",
        total: extract("total") || "0.00",
        invoiceStatus: unselectedInvoices.length === 0 ? "Re-Assigned" : "",
        batchNo: batchData?.batchNo || "",
        selectedService: "", // can fill if needed
        finalAmount: parseFloat(finalAmount).toFixed(2),
        gst: gstAmount,
        invoiceNo: invoiceNo || "",
        invoiceDate: invoiceDate || "",
        invoiceAmount: invoiceAmount || "0.00",
        invoice: existingInvoice?.url || "",
        vendorName: batchData?.vendorName || "",
        caseCount: batchData?.caseCount,
        totalRepairCharges: parseFloat(totalRepairCharges).toFixed(2),
        totalServiceCharges: totalservicechargewithGST,
        remarks: extract("remarks"),
        remarkFile: extract("remarkFile"),
        serviceCharges: extract("serviceCharges") || "0.00",
        uniqueRejected: selectedAA,
        uniquePending: unselectedAA,
        NetworkAndFinanceStatus: networkAndFinanceStatus,
      };

      console.log(payload, 'payloooo')
      // Required field validations
      if (!payload.aaNo) {
        toast.error("AA Numbers are required for partial approval.");
        return;
      }
      if (!payload.batchNo) {
        toast.error("Batch Number is required for partial approval.");
        return;
      }


      try {
        setLoading(true);
        console.log("Sending JSON for Partial Approval:", payload);

        const response = await fetch(
          `${BASE_URL}/Insert_NetworkRejectedBatches`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify(payload)
          }
        );

        const result = await response.json();
        console.log("network rejected", result)
        if (!response.ok) {
          console.error("API error for approval:", {
            status: response.status,
            statusText: response.statusText,
            responseBody: result
          });
          toast.error(
            `Error in approval: ${result.message || "Unknown error"
            } (Status: ${response.status})`
          );
          return;
        }
        const aanoString = selectedInvoices.map((item) => item.aA_Number).join(",");

        const remarkFormData = new FormData();
        remarkFormData.append("AANo", aanoString);
        remarkFormData.append("Remark", `${aanoString} Rejected by Network`);
        remarkFormData.append("BatchNo", batchData.batchNo);
        remarkFormData.append("ByWhom", user?.role);

        try {
          const res = await fetch(`${BASE_URL}/UpdateRemarkAgainstBatch`, {
            method: "POST",
            body: remarkFormData,
          });
        } catch (remarkError) {
          console.error("Failed to update remarks:", remarkError);
        }

        localStorage.removeItem("invoices");
        navigate("/invoice");
      } catch (error) {
        console.error("Approval failed:", {
          message: error.message,
          stack: error.stack,
          payload
        });
        toast.error(
          `Partial approval failed: ${error.message}. Check console for details.`
        );
      } finally {
        setLoading(false);
      }
    }
  };


  const allRowsChecked =
    invoices.length > 0 && invoices.every((invoice) => invoice.isChecked);

  function formatDate(input) {
    if (!input) return "-";
    const s = String(input).trim().replace(/\s+/g, " ");

    if (/^\d+(\.\d+)?$/.test(s)) {
      const serial = parseFloat(s);
      const ms = (serial - 25569) * 86400 * 1000;
      const d = new Date(ms);
      return isNaN(d) ? "-" : ddmmyyyy(d.getDate(), d.getMonth() + 1, d.getFullYear());
    }

    let m;

    m = s.match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T]\d{2}:\d{2}(?::\d{2})?)?$/);
    if (m) return ddmmyyyy(Number(m[3]), Number(m[2]), Number(m[1]));

    m = s.match(/^(\d{2})-(\d{2})-(\d{4})(?:[ T]\d{2}:\d{2}(?::\d{2})?)?$/);
    if (m) return ddmmyyyy(Number(m[1]), Number(m[2]), Number(m[3]));

    m = s.match(/^([A-Za-z]{3}) (\d{1,2}) (\d{4})(?: (\d{1,2})(?::(\d{2}))?(AM|PM))?$/i);
    if (m) {
      const monthMap = { jan: 1, feb: 2, mar: 3, apr: 4, may: 5, jun: 6, jul: 7, aug: 8, sep: 9, oct: 10, nov: 11, dec: 12 };
      const month = monthMap[m[1].toLowerCase()];
      const day = Number(m[2]);
      const year = Number(m[3]);
      if (month && day && year) return ddmmyyyy(day, month, year);
    }

    const nd = new Date(s.replace(" ", "T"));
    if (!isNaN(nd)) return ddmmyyyy(nd.getDate(), nd.getMonth() + 1, nd.getFullYear());

    return "-";

    function ddmmyyyy(d, m, y) {
      const dd = String(d).padStart(2, "0");
      const mm = String(m).padStart(2, "0");
      return `${dd}/${mm}/${y}`;
    }
  }

  const getFileNameFromUrl = (url) => {
    const params = new URLSearchParams(url.split("?")[1]);
    return decodeURIComponent(params.get("fileName"));
  };

  const isPdf = (url) => {
    return url.toLowerCase().includes(".pdf");
  };

  const [imagePreviewUrl, setImagePreviewUrl] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const handlePreview = (url) => {
    if (!isPdf(url)) {
      setImagePreviewUrl(url);
      setShowModal(true);
    } else {
      window.open(url, "_blank");
    }
  };
  const selectedAAnoCase = invoices.filter(
    (invoice) => invoice.isChecked && !isRowDisabled(invoice)
  );
  useEffect(() => {
    setCaseCount(leftSideCaseCount.toString());
  }, [leftSideCaseCount]);

  useEffect(() => {
    setInvoiceAmount(leftSideFinalAmount);
  }, [leftSideFinalAmount]);
  const handleLOGSremarks = (aa_number) => {
    navigate(`/Remarks&Logs/${aa_number}`)
  }
  const hasInvoiceApprovedStatus = () => {
    return invoices.some(invoice =>
      invoice.networkAndFinanceStatus === "Invoice Approved"
    );
  };
  return (
    <>
      <style>
        {`
          .row-red { background-color: #ffe6e6; color: #d32f2f; }
          .row-yellow { background-color: #fff9c4; }
          .row-green { background-color: #e8f5e9; }
          .approval-page-container { padding: 20px; max-width: 1212px; margin: 0 auto; }
          .batch_popup_upload {
            background-color: #8000d7; color: white; border: none;
            padding: 10px 16px; border-radius: 8px; font-weight: 500;
            font-size: 14px; display: flex; align-items: center; cursor: pointer;
          }
          .batch_popup_upload:hover { background-color: #6b00b8; }
          .table-container { overflow-x: auto; overflow-y: auto; max-height: 400px; width: 100%; }
          .network_table { min-width: 1200px; }
          .network_table th, .network_table td { padding: 8px; vertical-align: middle; white-space: nowrap; }
          .vendore_invoice_status { white-space: nowrap; }
        `}
      </style>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
      />
      {showModal && (
        <div
          className="custom-modal"
          onClick={() => setShowModal(false)}
        >
          <span className="close">&times;</span>
          <img src={imagePreviewUrl} alt="Preview" className="modal-content" />
        </div>
      )}
      {/* {showRemarkModal && (
        <div className="modal show fade d-block" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content custom-modal">
              <div className="modal-header">
                <h5 className="modal-title">
                  All selected cases will be <strong>{modalActionType}</strong>
                </h5>
                <button type="button" className="btn-close" onClick={() => setShowRemarkModal(false)}></button>
              </div>
              <div className="modal-body">
                <textarea
                  className="form-control"
                  rows="4"
                  placeholder="Enter your remarks..."
                  value={batchRemark}
                  onChange={(e) => setBatchRemark(e.target.value)}
                />
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowRemarkModal(false)}>Cancel</button>
                <button className="btn btn-primary" onClick={handleSaveRemark}>Save Remark</button>
              </div>
            </div>
          </div>
        </div>
      )} */}

      <div className="approval-page-container">
        <h2 className="mb-4">Invoice Approval</h2>
        <div className="mt-4">
          <div className="netwrok_table_main_content">
            <div className="d-flex justify-content-between align-items-center gap-2 mb-3">
              <div className="d-flex flex-wrap gap-4 align-items-center">
                {batchData?.batchNo && (
                  <div className="fw-semibold">
                    <span>Batch No: </span>
                    <span className="text-primary">{batchData.batchNo}</span>
                  </div>
                )}
                {batchData?.vendorName && (
                  <div className="fw-semibold">
                    <span>Vendor: </span>
                    <span className="text-success">{batchData.vendorName}</span>
                  </div>
                )}
              </div>
              <div className="d-flex gap-2">
                {/* {existingInvoice.url && (
                  <button
                    className="batch_popup_upload"
                    onClick={handleDownloadInvoice}
                  >
                    <FaDownload />{" "}
                    <span className="ms-2">Download Invoice</span>
                  </button>
                )} */}
                <button className="batch_popup_upload" onClick={handleClick}>
                  <FaUpload />{" "}
                  <span className="ms-2">
                    {/* {existingInvoice.url ? "Update Invoice" : "Upload Invoice"} */}
                    {existingInvoice.url ? "Update Invoice" : "Update Invoice"}

                  </span>
                </button>
                <input
                  type="file"
                  ref={fileInputRef}
                  onChange={handleFileChange}
                  style={{ display: "none" }}
                  accept="*"
                />
              </div>
            </div>
            <div className="d-flex justify-content-end text-end upload_file_ext_name mb-3">
              {existingInvoice.url && !uploadedFile && (
                <div style={{ fontWeight: "bold", color: "green", display: "flex", alignItems: "center", gap: "10px" }}>
                  {/* <span>{getFileNameFromUrl(existingInvoice.url)}</span> */}
                  <span
                    onClick={() => window.open(existingInvoice.url, "_blank")}
                    style={{ cursor: "pointer" }}>{getFileNameFromUrl(existingInvoice.url)}</span>
                  {isPdf(existingInvoice.url) ? (
                    <img src={pdfimage} alt="PDF" style={{ width: "24px", height: "24px" }} />
                  ) : (
                    <img src={existingInvoice.url} alt="Preview" style={{ width: "24px", height: "24px" }} />
                  )}
                </div>
              )}

              {uploadedFile && fileType && (
                <div style={{ fontWeight: "bold", color: "green" }}>
                  Uploaded File: {uploadedFile.name} (Type: {fileType})
                </div>
              )}

              {fieldErrors.invoiceFile && (
                <div className="text-danger mt-1" style={{ fontSize: "14px" }}>
                  Please upload an invoice file.
                </div>
              )}
            </div>
            <Modal show={openRemarkModal} onHide={() => setOpenRemarkModal(false)} centered size="md">
              <Modal.Header closeButton style={{ backgroundColor: "#EBF3FF" }}>
                <Modal.Title>Add Remark</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form>
                  <Form.Group className="mb-3">
                    <Form.Label>Remarks</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={remarks}
                      onChange={(e) => setRemarks(e.target.value)}
                      placeholder="Enter remark"
                    />
                  </Form.Group>
                </Form>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="danger" onClick={() => setOpenRemarkModal(false)}>
                  Cancel
                </Button>
                <Button
                  variant="primary"
                  onClick={handleRemarkSubmit}
                  style={{ backgroundColor: "#8000d7", border: "none" }}
                >
                  Submit
                </Button>
              </Modal.Footer>
            </Modal>
            <div className="table-container mt-3">
              <Table className="bg-white text-center border-0 network_table">
                <thead
                  style={{
                    backgroundColor: "#EEF4FF",
                    position: "sticky",
                    top: 0,
                    zIndex: 1,
                  }}
                >
                  <tr className="text-dark fw-semibold table_th_border">
                    <th className="border-start d-flex gap-2">
                      <Form.Check
                        type="checkbox"
                        checked={
                          invoices.length > 0 &&
                          invoices.every((invoice) => invoice.isChecked)
                        }
                        onChange={() => handleCheckboxChange("all")}
                        disabled={invoices.some((inv) => isRowDisabled(inv))}
                      />

                      Select
                    </th>
                    <th className=" border-start">View</th>
                    <th className="border-start">Edit</th>
                    <th className="border-start">Remarks</th>

                    <th className="border-end border-start" style={{ whiteSpace: "nowrap" }}>
                      Action
                    </th>
                    <th style={{ whiteSpace: "nowrap" }}>AA No</th>
                    <th style={{ whiteSpace: "nowrap" }}>IMEI No</th>
                    {/* <th style={{ whiteSpace: "nowrap" }}>Creation Date</th> */}
                    {/* <th style={{ whiteSpace: "nowrap" }}>Closure Date</th> */}
                    <th style={{ whiteSpace: "nowrap" }}>Customer Name</th>
                    {/* <th style={{ whiteSpace: "nowrap" }}>Service Type</th> */}
                    <th style={{ whiteSpace: "nowrap" }}>Brand</th>
                    <th style={{ whiteSpace: "nowrap" }}>Make Model</th>
                    <th style={{ whiteSpace: "nowrap" }}>Repair Charges</th>
                    <th style={{ whiteSpace: "nowrap" }}>Service Charges(Pre GST)</th>
                    <th style={{ whiteSpace: "nowrap" }}>Total</th>
                    <th style={{ whiteSpace: "nowrap" }}>Invoice Status</th>
                    <th style={{ whiteSpace: "nowrap" }}>UTR No</th>
                    <th style={{ whiteSpace: "nowrap" }}>Mismatched Data</th>
                    <th style={{ whiteSpace: "nowrap" }}>Remarks</th>
                    <th style={{ whiteSpace: "nowrap" }}>Remarks File</th>
                    <th style={{ whiteSpace: "nowrap" }}>Document</th>
                    <th className="border-end" style={{ whiteSpace: "nowrap" }}>Billing Type</th>
                  </tr>
                </thead>
                <tbody>
                  {loading && (
                    <tr>
                      <td colSpan="21" className="text-center py-3">
                        Validating data...
                      </td>
                    </tr>
                  )}
                  {!loading &&
                    currentInvoices.map((invoice, index) => {
                      const disabled = isRowDisabled(invoice);

                      return (
                        <tr
                          key={
                            invoice.aA_Number || `${invoice.aA_Number}-${index}`
                          }
                          className={`text-center border-bottom network_td_item ${getRowClassName(invoice)} ${isRowDisabled(invoice) ? 'table-row-disabled' : ''}`}
                          style={{
                            opacity: isRowDisabled(invoice) ? 0.6 : 1,
                            backgroundColor: isRowDisabled(invoice) ? '#f2f2f2' : 'transparent',
                            pointerEvents: isRowDisabled(invoice) ? 'none' : 'auto'
                          }}
                          aria-label={
                            getRowClassName(invoice).replace("row-", "") + " row"
                          }
                        >
                          <td className="border-start align-middle">
                            <Form.Check
                              type="checkbox"
                              checked={invoice.isChecked}
                              onChange={() =>
                                handleCheckboxChange(invoice.aA_Number)
                              }
                              disabled={loading || isDisabled}
                            />
                          </td>
                          <td className="align-middle border-start"
                            style={{ pointerEvents: "auto" }}
                          >
                            <IconButton
                              // onClick={() =>
                              //   navigate("/invoice-template", {
                              //     state: {
                              //       aaNumber: invoice.aA_Number,
                              //       invoiceData: invoice,
                              //     },
                              //   })
                              // }
                              onClick={() => handleViewClick(invoice.aA_Number)}

                            >
                              <FaEye
                                size={20}
                                className="text-purple review_fa_eye"
                                style={{ cursor: "pointer" }}
                              />
                            </IconButton>
                          </td>

                          {/* <td className="align-middle" >
                          <FaEdit
                            size={20}
                            className="text-purple-600 review_fa_eye"
                            style={{ cursor: "pointer" }}
                            onClick={() => handleEdit(invoice)}
                             disabled={loading || isDisabled}
                          />
                        </td> */}
                          <td className="align-middle border-start">
                            <button
                              onClick={() => handleEdit(invoice)}
                              disabled={loading || isDisabled}
                              style={{
                                background: "none",
                                border: "none",
                                padding: 0,
                                cursor: loading || isDisabled ? "not-allowed" : "pointer"
                              }}
                            >
                              <FaEdit
                                size={20}
                                className="text-purple-600 review_fa_eye"
                              />
                            </button>
                          </td>
                          <td className="border-start align-middle">
                            <FaReceipt
                              size={20}
                              className="text-purple-600 review_fa_eye"
                              style={{ cursor: "pointer" }}
                              onClick={() => handleLOGSremarks(invoice.aA_Number)}
                            />
                          </td>
                          <td className="align-middle border-end border-start">
                            <FaTrash
                              size={20}
                              style={{ cursor: "pointer", color: "red" }}
                              onClick={() => handleDelete(invoice.aA_Number)}
                            />
                          </td>
                          <td className="align-middle">
                            {invoice.aA_Number || "-"}
                          </td>
                          <td className="align-middle">
                            {invoice.imeiNumber || "-"}
                          </td>
                          {/* <td className="align-middle">
                            {invoice.creationDate
                              ? formatDate(invoice.creationDate)
                              : "-"}
                          </td>
                          <td className="align-middle">
                            {invoice.closureDate
                              ? formatDate(invoice.closureDate)
                              : "-"}
                          </td> */}
                          <td className="align-middle">
                            {invoice.customerName || "-"}
                          </td>
                          {/* <td className="align-middle">
                            {invoice.serviceType || "-"}
                          </td> */}
                          <td className="align-middle">{invoice.brand || "-"}</td>
                          <td className="align-middle">
                            {invoice.makeModel || "-"}
                          </td>
                          <td className="align-middle">
                            {invoice.repairCharges || "0.00"}
                          </td>
                          <td className="align-middle">
                            {invoice.serviceCharges || "0.00"}
                          </td>
                          <td className="align-middle">
                            {invoice.total || "0.00"}
                          </td>
                          {/* <td className="align-middle">
                            <span className="vendore_invoice_status px-3 py-1 rounded-pill">
                              {invoice.networkAndFinanceStatus || "-"}
                            </span>
                          </td> */}
                          {/* <td className="align-middle">
                            <span className="vendore_invoice_status px-3 py-1 rounded-pill">
                              {invoice.utrNo && invoice.utrNo.trim() !== "-" && invoice.utrNo.trim() !== ""
                                ? "Payment Done"
                                : invoice.networkAndFinanceStatus || "-"}
                            </span>
                          </td> */}
                          <td className="align-middle">
                            {(() => {
                              const displayStatus = "Billed";

                              const statusStyle = statusColor[displayStatus.trim()] || {
                                color: "#6B7280",
                                backgroundColor: "#F3F4F6",
                              };

                              return (
                                <span
                                  className="vendore_invoice_status px-3 py-1 rounded-pill"
                                  style={{
                                    backgroundColor: statusStyle.backgroundColor,
                                    color: statusStyle.color,
                                    border: `1px solid ${statusStyle.color}`,
                                    fontSize: "13px",
                                    fontWeight: "600",
                                  }}
                                >
                                  {displayStatus}
                                </span>
                              );
                            })()}
                          </td>
                          <td className="align-middle">
                            {invoice.utrNo || "-"}
                          </td>
                          <td
                            className="align-middle position-relative"
                            onMouseEnter={() => setHoveredRow(index)}
                            onMouseLeave={() => setHoveredRow(null)}
                          >
                            {getDifferencesData(invoice).length > 0
                              ? "Mismatch"
                              : "Valid"}
                            {hoveredRow === index &&
                              getDifferencesData(invoice).length > 0 && (
                                <div
                                  style={{
                                    position: "absolute",
                                    top: "100%",
                                    left: "-18%",
                                    transform: "translateX(-50%)",
                                    zIndex: 1000,
                                    backgroundColor: "#fff",
                                    border: "1px solid #ddd",
                                    padding: "10px",
                                    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                                    minWidth: "300px",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  <table className="table table-sm table-bordered mb-0">
                                    <thead>
                                      <tr>
                                        <th>Field</th>
                                        <th>Excel Data</th>
                                        <th>System Data</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {getDifferencesData(invoice).map(
                                        (diff, i) => (
                                          <tr key={i}>
                                            <td>{diff.field}</td>
                                            <td>{diff.table}</td>
                                            <td>{diff.api}</td>
                                          </tr>
                                        )
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              )}
                          </td>
                          <td className="align-middle">
                            {invoice.remarks || "no remarks"}
                          </td>
                          <td className="align-middle">
                            {invoice.remarkFileUrl ? (
                              <a
                                href={invoice.remarkFileUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  color: "#8000d7",
                                  textDecoration: "underline",
                                }}
                              >
                                View File
                              </a>
                            ) : (
                              "-"
                            )}
                          </td>
                          <td className="align-middle">
                            {invoice.documentFileUrl ? (
                              <a
                                href={invoice.documentFileUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  color: "#8000d7",
                                  textDecoration: "underline",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                View PDF
                              </a>
                            ) : (
                              "-"
                            )}
                          </td>
                          <td className="align-middle border-end">
                            {invoice.billingType || "-"}
                          </td>
                        </tr>
                      )
                    })}
                </tbody>
              </Table>
            </div>
            <div className="d-flex justify-content-between align-items-center pagination-container mt-3">
              <button
                className="btn btn-outline-primary"
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
              >
                Previous
              </button>
              <span className="page-info">
                Page {currentPage} of {totalPages}
              </span>
              <button
                className="btn btn-outline-primary"
                onClick={() =>
                  setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                }
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </div>
            <div className="row justify-content-between align-items-start mt-2">
              {/* Left Column */}
              <div className="col-12">
                {/* GST Toggle */}
                <div className="border rounded p-2 mt-4">
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="fw-bold ms-2">
                      <span>GST</span>
                    </div>
                    <div className="d-flex gap-3">
                      <label className="registration_kc_radio">
                        <input
                          type="radio"
                          name="gstApplied"
                          checked={isGSTApplied === true}
                          onChange={() => setIsGSTApplied(true)}
                          disabled={loading || isDisabled}
                        />
                        <span className="registration_applied_yes">Yes</span>
                      </label>
                      <span className="mx-1">/</span>
                      <label className="registration_kc_radio">
                        <input
                          type="radio"
                          name="gstApplied"
                          checked={isGSTApplied === false}
                          onChange={() => setIsGSTApplied(false)}
                          disabled={loading || isDisabled}
                        />
                        <span className="registration_applied_yes">No</span>
                      </label>
                    </div>
                  </div>
                </div>

                {/* Selected Services */}
                <div
                  style={{
                    backgroundColor: "#eef4ff",
                    marginTop: "8px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "8px",
                    padding: "16px",
                    whiteSpace: "nowrap",
                  }}
                >
                  <span style={{ fontWeight: 600, color: "gray" }}>
                    Total no of selected invoices:
                  </span>
                  <span style={{ fontWeight: "bold", color: "black" }}>
                    {leftSideCaseCount}
                  </span>
                </div>

                {/* Amount Summary */}
                <div
                  className="batch_popup_gross_ammount mt-2 w-100"
                  style={{ backgroundColor: "#eef4ff" }}
                >
                  <div className="d-flex justify-content-between batch_popup_amount">
                    <div className="fw-bold batch_gross">Total Repair Charges</div>
                    <div className="text-end batch_amount_to_fix">
                      ₹ {parseFloat(leftSideTotalRepairCharges).toFixed(2)}
                    </div>
                  </div>

                  <div className="d-flex justify-content-between batch_popup_amount">
                    <div className="fw-bold batch_gross">Total Service Charges</div>
                    <div className="d-flex align-items-center">
                      <div className="batch_amount_to_fix">
                        ₹ {leftSideTotalservicechargewithGST} ({isGSTApplied ? "incl GST 18%" : "excl GST"})
                      </div>
                    </div>
                  </div>

                  <div className="d-flex justify-content-between batch_popup_amount">
                    <div className="fw-bold batch_gross">Total Amount</div>
                    <div className="batch_amount_to_fix" style={{ fontSize: "14px" }}>
                      <b>₹ {leftSideFinalAmount}</b>
                    </div>
                  </div>

                  <div className="mt-2 d-flex justify-content-end">
                    <span className="fw-semibold text-secondary" style={{ fontSize: "13px" }}>
                      {isGSTApplied
                        ? `GST Amount Added: ₹${leftSideGstAmount}`
                        : `No GST Applied (₹${leftSideGstAmount})`}
                    </span>
                  </div>
                </div>
              </div>


            </div>

            <div className="d-flex mt-4 justify-content-center align-items-center flex-wrap gap-3">
              <Button
                onClick={downloadCSV}
                className="d-flex align-items-center"
                style={{
                  backgroundColor: "rgb(248, 238, 255)",
                  border: "1px solid #8000d7",
                  padding: "10px 50px",
                  borderRadius: "8px",
                  fontWeight: "500",
                  fontSize: "16px",
                  color: "#8000d7",
                }}
              >
                <FaDownload />
                <span className="ms-2">Download</span>
              </Button>
              {/* {allRowsChecked && (
                <Button
                  onClick={handleSubmit}
                  className="d-flex align-items-center"
                  style={{
                    backgroundColor: "#8000d7",
                    border: "none",
                    padding: "10px 16px",
                    fontWeight: "bold",
                    fontSize: "16px",
                    color: "white",
                  }}
                  disabled={loading}
                >
                  <span>{loading ? "Submitting..." : "Approve"}</span>
                </Button>
              )}

              <Button
                onClick={handleSendAction}
                className="d-flex align-items-center"
                style={{
                  backgroundColor: "#8000d7",
                  border: "none",
                  padding: "10px 16px",
                  fontWeight: "bold",
                  fontSize: "16px",
                  color: "white",
                }}
                disabled={loading}
              >
                <span>{loading ? "Submitting..." : "Partial Or Back"}</span>
              </Button> */}
              <button
                onClick={handleSaveData}
                className="btn btn-primary d-flex align-items-center"
                style={{
                  backgroundColor: "#8000d7",
                  border: "none",
                  padding: "10px 50px",
                  borderRadius: "8px",
                  fontWeight: "500",
                  fontSize: "16px",
                  color: "white",
                }}
                disabled={loading || isDisabled || !hasAnySelected || !allRowsChecked}
              // disabled={isLoading}
              >
                Save
              </button>
              
              <div style={{ display: "flex", gap: "10px" }}>
                  {user?.role === "NetworkAdmin" && (
                <Button
                  onClick={handleSubmit}
                  className="d-flex align-items-center"
                  style={{
                    backgroundColor: "#8000d7",
                    border: "none",
                    padding: "10px 16px",
                    fontWeight: "bold",
                    fontSize: "16px",
                    color: "white",
                  }}
                  disabled={loading || isDisabled || !hasAnySelected}
                >
                  <span>{loading ? "Processing..." : "Approve"}</span>
                </Button>
                  )}
                
                {/* {!allRowsChecked && (
                  <Button
                    onClick={handleSendPartialAction}
                    className="d-flex align-items-center"
                    style={{
                      backgroundColor: "#ff9800",
                      border: "none",
                      padding: "10px 16px",
                      fontWeight: "bold",
                      fontSize: "16px",
                      color: "white",
                    }}
                    disabled={loading || isDisabled || !hasAnySelected}
                  >
                    <span>{loading ? "Processing..." : "Partial"}</span>
                  </Button>
                )} */}

                {/* <Button
                  onClick={handleSendBackAction}
                  className="d-flex align-items-center"
                  style={{
                    backgroundColor: "#8000d7",
                    border: "none",
                    padding: "10px 16px",
                    fontWeight: "bold",
                    fontSize: "16px",
                    color: "white",
                  }}
                  disabled={loading || isDisabled || !hasAnySelected}
                >
                  <span>{loading ? "Processing..." : "Send Back"}</span>
                </Button> */}
                {user?.role === "NetworkAdmin" && (
                <Button
                  onClick={handleNetworkReject}
                  className="d-flex align-items-center"
                  style={{
                    backgroundColor: "#f44336",
                    border: "none",
                    padding: "10px 16px",
                    fontWeight: "bold",
                    fontSize: "16px",
                    color: "white",
                  }}
                  disabled={loading || isDisabled || !hasAnySelected}
                >
                  <span>{loading ? "Processing..." : "Reject"}</span>
                </Button>
                )}

              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal show={showEditModal} onHide={handleCloseModal} centered size="xl">
        <Modal.Header closeButton style={{ backgroundColor: "#EBF3FF" }}>
          <Modal.Title>
            Edit Invoice (AA Number: {editingInvoice?.aA_Number || "-"})
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            {/* Left Side: Form Controls */}
            <div className="col-md-5 border-end">
              <Form>
                <Form.Group className="mb-3">
                  <Form.Label>Billing Type</Form.Label>
                  <Form.Select
                    name="billingType"
                    value={editValues.billingType}
                    onChange={handleEditInputChange}
                    size="lg"
                  >
                    <option value="billing">Billing</option>
                    <option value="reimbursement">Reimbursement</option>
                  </Form.Select>
                </Form.Group>
                {editValues.billingType === "reimbursement" ? (
                  <Alert variant="info" className="mb-3">
                    <strong>Reimbursement Mode:</strong>
                    <ul className="mb-0 mt-2">
                      <li>Repair Charges → Reimbursement Challan</li>
                      <li>Service Charges → Service Invoice</li>
                    </ul>
                  </Alert>
                ) : (
                  <Alert variant="info" className="mb-3">
                    <strong>Billing Mode:</strong>
                    <ul className="mb-0 mt-2">
                      <li>
                        Single Invoice will be generated for total amount (
                        Repair Charges + Service Charges)
                      </li>
                    </ul>
                  </Alert>
                )}
                <Form.Group className="mb-3">
                  <Form.Label>Repair Charges</Form.Label>
                  <Form.Control
                    type="number"
                    name="repairCharges"
                    value={editValues.repairCharges}
                    onChange={handleEditInputChange}
                    min="0"
                    step="0.01"
                    placeholder="0.00"
                    size="lg"
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Service Charges</Form.Label>
                  <Form.Control
                    type="number"
                    name="serviceCharges"
                    value={editValues.serviceCharges}
                    onChange={handleEditInputChange}
                    min="0"
                    step="0.01"
                    placeholder="0.00"
                    size="lg"
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Remarks</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    name="remarks"
                    value={editValues.remarks}
                    onChange={handleEditInputChange}
                    placeholder="Enter remark"
                    className={
                      fieldErrors.remarks?.[editingInvoice?.aA_Number]
                        ? "is-invalid"
                        : ""
                    }
                  />
                  {fieldErrors.remarks?.[editingInvoice?.aA_Number] && (
                    <div className="text-danger mt-1" style={{ fontSize: "14px" }}>
                      Remarks are required for mismatched data.
                    </div>
                  )}
                </Form.Group>

                <Form.Group className="mb-3" controlId="formFile">
                  <Form.Label
                    className="btn btn-secondary mb-0"
                    style={{ backgroundColor: "#8000d7", border: "none" }}
                    onClick={() => modalFileInputRef.current.click()}
                  >
                    Upload File
                  </Form.Label>

                  <Form.Control
                    type="file"
                    id="fileUpload"
                    name="file"
                    onChange={handleModalFileChange}
                    style={{ display: "none" }}
                    ref={modalFileInputRef}
                  />

                  {editValues.fileName && (
                    <div className="mt-2 d-flex align-items-center">
                      <span className="text-muted me-2">
                        Selected File: {editValues.fileName}
                      </span>
                      {editValues.remarkFile &&
                        editValues.remarkFile.type === "application/pdf" && (
                          <Button
                            variant="link"
                            className="p-0 ms-2"
                            onClick={() => setShowPreview(!showPreview)}
                            style={{ fontSize: "14px", color: "#8000d7" }}
                          >
                            <FaEye className="me-1" />{" "}
                            {showPreview ? "Hide Preview" : "Show Preview"}
                          </Button>
                        )}
                    </div>
                  )}

                  {showPreview &&
                    editValues.remarkFile &&
                    editValues.remarkFile.type === "application/pdf" && (
                      <div
                        className="mt-3"
                        style={{
                          border: "1px solid #ddd",
                          borderRadius: "4px",
                          overflow: "hidden",
                        }}
                      >
                        <iframe
                          src={URL.createObjectURL(editValues.remarkFile)}
                          style={{ width: "100%", height: "400px", border: "none" }}
                          title="PDF Preview"
                          onLoad={() => {
                            setTimeout(
                              () =>
                                URL.revokeObjectURL(
                                  URL.createObjectURL(editValues.remarkFile)
                                ),
                              10000
                            );
                          }}
                        />
                      </div>
                    )}
                </Form.Group>
              </Form>
            </div>

            {/* Right Side: Document Preview & Downloads */}
            <div className="col-md-7 d-flex flex-column" style={{ minHeight: "550px" }}>
              <div className="d-flex justify-content-between align-items-center mb-2 pb-2 border-bottom">
                <span className="fw-bold text-dark" style={{ fontSize: "16px" }}>Document Live Preview</span>
                {editValues.billingType === "reimbursement" && (
                  <div className="d-flex gap-2">
                    <Button
                      variant={activePreviewTab === "challan" ? "primary" : "outline-primary"}
                      onClick={() => setActivePreviewTab("challan")}
                      size="sm"
                      style={{ fontSize: "11px", padding: "4px 8px" }}
                    >
                      Challan (Repair)
                    </Button>
                    <Button
                      variant={activePreviewTab === "invoice" ? "primary" : "outline-primary"}
                      onClick={() => setActivePreviewTab("invoice")}
                      size="sm"
                      style={{ fontSize: "11px", padding: "4px 8px" }}
                    >
                      Logistics Invoice (Logistics)
                    </Button>
                  </div>
                )}
              </div>

              {/* Scrollable Preview Frame */}
              <div className="flex-grow-1 overflow-auto border rounded bg-light p-2 mb-3" style={{ maxHeight: "500px" }}>
                {renderDocumentPreview()}
              </div>

              {/* Download buttons bar */}
              <div className="d-flex gap-2 justify-content-end align-items-center border-top pt-2">
                <span className="text-muted me-auto" style={{ fontSize: "11px" }}>
                  * Preview shows dynamic data based on inputs & API response.
                </span>
                {editValues.billingType === "billing" ? (
                  <Button
                    variant="success"
                    onClick={() => downloadInvoicePDF(editingInvoice, [...getDisplayItems().repair, ...getDisplayItems().service])}
                    size="sm"
                    className="d-flex align-items-center gap-1"
                    style={{ backgroundColor: "#28a745", borderColor: "#28a745" }}
                  >
                    <FaDownload /> Download Tax Invoice
                  </Button>
                ) : (
                  <>
                    <Button
                      variant="success"
                      onClick={() => downloadChallanPDF(editingInvoice, getDisplayItems().repair)}
                      size="sm"
                      className="d-flex align-items-center gap-1"
                      style={{ backgroundColor: "#28a745", borderColor: "#28a745" }}
                    >
                      <FaDownload /> Download Challan
                    </Button>
                    <Button
                      variant="success"
                      onClick={() => downloadInvoicePDF(editingInvoice, getDisplayItems().service)}
                      size="sm"
                      className="d-flex align-items-center gap-1"
                      style={{ backgroundColor: "#28a745", borderColor: "#28a745" }}
                    >
                      <FaDownload /> Download Logistics Invoice
                    </Button>
                  </>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleCloseModal}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={() => handleSaveEdit(editingInvoice?.aA_Number)}
            style={{ backgroundColor: "#8000d7", border: "none" }}
          >
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ApprovalBatchPage;
